/* tslint:disable */
/*
 * Autogenerated by @creditkarma/thrift-typescript v2.0.14
 * DO NOT EDIT UNLESS YOU ARE SURE THAT YOU KNOW WHAT YOU ARE DOING
*/

import * as thrift from "thrift";
import { Int64 } from "thrift";
import * as PContact from "./../../common/models";
import * as PLocation from "./../../common/models";
import * as Authenticate from "./../../authentication/messages";
import * as Share from "./../../share/messages";
import * as PNameSuggestion from "./.";
import * as PUnarchiveSuggestion from "./.";
import * as InAppPurchases from "./../../connectedaccount/messages";
import * as Export from "./../../export/messages";
export enum TAppInconsistencyResolution {
    PENDING = 0,
    NO_INCONSISTENCY = 1,
    MOBILE = 2,
    LANDLINE = 3,
    EMAIL = 4,
    PROF_INFO = 5,
    ADDRESS = 6,
    NO_ANCHOR = 7
}
export interface ITAppInconsistentContactArgs {
    uniqueHash: string;
    contact?: PContact.TAppContact;
    reason?: string;
    resolution?: TAppInconsistencyResolution;
    notes?: string;
}
export class TAppInconsistentContact {
    public uniqueHash: string;
    public contact?: PContact.TAppContact;
    public reason?: string;
    public resolution?: TAppInconsistencyResolution;
    public notes?: string;
    constructor(args: ITAppInconsistentContactArgs) {
        if (args != null && args.uniqueHash != null) {
            this.uniqueHash = args.uniqueHash;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[uniqueHash] is unset!");
        }
        if (args != null && args.contact != null) {
            this.contact = args.contact;
        }
        if (args != null && args.reason != null) {
            this.reason = args.reason;
        }
        if (args != null && args.resolution != null) {
            this.resolution = args.resolution;
        }
        if (args != null && args.notes != null) {
            this.notes = args.notes;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppInconsistentContact");
        if (this.uniqueHash != null) {
            output.writeFieldBegin("uniqueHash", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.uniqueHash);
            output.writeFieldEnd();
        }
        if (this.contact != null) {
            output.writeFieldBegin("contact", thrift.Thrift.Type.STRUCT, 2);
            this.contact.write(output);
            output.writeFieldEnd();
        }
        if (this.reason != null) {
            output.writeFieldBegin("reason", thrift.Thrift.Type.STRING, 3);
            output.writeString(this.reason);
            output.writeFieldEnd();
        }
        if (this.resolution != null) {
            output.writeFieldBegin("resolution", thrift.Thrift.Type.I32, 4);
            output.writeI32(this.resolution);
            output.writeFieldEnd();
        }
        if (this.notes != null) {
            output.writeFieldBegin("notes", thrift.Thrift.Type.STRING, 5);
            output.writeString(this.notes);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppInconsistentContact {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_1: string = input.readString();
                        _args.uniqueHash = value_1;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_2: PContact.TAppContact = PContact.TAppContact.read(input);
                        _args.contact = value_2;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_3: string = input.readString();
                        _args.reason = value_3;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_4: TAppInconsistencyResolution = input.readI32();
                        _args.resolution = value_4;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_5: string = input.readString();
                        _args.notes = value_5;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.uniqueHash !== undefined) {
            return new TAppInconsistentContact(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppInconsistentContact from input");
        }
    }
}
export interface ITInconsistentContactsFetchRequestArgs {
    maxPageSize: number;
}
export class TInconsistentContactsFetchRequest {
    public maxPageSize: number;
    constructor(args: ITInconsistentContactsFetchRequestArgs) {
        if (args != null && args.maxPageSize != null) {
            this.maxPageSize = args.maxPageSize;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[maxPageSize] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TInconsistentContactsFetchRequest");
        if (this.maxPageSize != null) {
            output.writeFieldBegin("maxPageSize", thrift.Thrift.Type.I32, 1);
            output.writeI32(this.maxPageSize);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TInconsistentContactsFetchRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_6: number = input.readI32();
                        _args.maxPageSize = value_6;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.maxPageSize !== undefined) {
            return new TInconsistentContactsFetchRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TInconsistentContactsFetchRequest from input");
        }
    }
}
export interface ITInconsistentContactsFetchResponseArgs {
    inconsistentContacts: Array<TAppInconsistentContact>;
}
export class TInconsistentContactsFetchResponse {
    public inconsistentContacts: Array<TAppInconsistentContact>;
    constructor(args: ITInconsistentContactsFetchResponseArgs) {
        if (args != null && args.inconsistentContacts != null) {
            this.inconsistentContacts = args.inconsistentContacts;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[inconsistentContacts] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TInconsistentContactsFetchResponse");
        if (this.inconsistentContacts != null) {
            output.writeFieldBegin("inconsistentContacts", thrift.Thrift.Type.LIST, 1);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.inconsistentContacts.length);
            this.inconsistentContacts.forEach((value_7: TAppInconsistentContact): void => {
                value_7.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TInconsistentContactsFetchResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_8: Array<TAppInconsistentContact> = new Array<TAppInconsistentContact>();
                        const metadata_1: thrift.TList = input.readListBegin();
                        const size_1: number = metadata_1.size;
                        for (let i_1: number = 0; i_1 < size_1; i_1++) {
                            const value_9: TAppInconsistentContact = TAppInconsistentContact.read(input);
                            value_8.push(value_9);
                        }
                        input.readListEnd();
                        _args.inconsistentContacts = value_8;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.inconsistentContacts !== undefined) {
            return new TInconsistentContactsFetchResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TInconsistentContactsFetchResponse from input");
        }
    }
}
export interface ITInconsistentContactUpdateRequestArgs {
    inconsistentContact: TAppInconsistentContact;
}
export class TInconsistentContactUpdateRequest {
    public inconsistentContact: TAppInconsistentContact;
    constructor(args: ITInconsistentContactUpdateRequestArgs) {
        if (args != null && args.inconsistentContact != null) {
            this.inconsistentContact = args.inconsistentContact;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[inconsistentContact] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TInconsistentContactUpdateRequest");
        if (this.inconsistentContact != null) {
            output.writeFieldBegin("inconsistentContact", thrift.Thrift.Type.STRUCT, 1);
            this.inconsistentContact.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TInconsistentContactUpdateRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_10: TAppInconsistentContact = TAppInconsistentContact.read(input);
                        _args.inconsistentContact = value_10;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.inconsistentContact !== undefined) {
            return new TInconsistentContactUpdateRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TInconsistentContactUpdateRequest from input");
        }
    }
}
export interface ITInconsistentContactUpdateResponseArgs {
}
export class TInconsistentContactUpdateResponse {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TInconsistentContactUpdateResponse");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TInconsistentContactUpdateResponse {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TInconsistentContactUpdateResponse();
    }
}
export enum TAppHomePageModule {
    UNDEFINED = 0,
    WELCOME = 1,
    DASHBOARD = 2,
    TOP_CONTACTS = 3,
    NEARBY = 4,
    BIRTHDAYS = 5,
    MERGE_CONFIRMATION = 6,
    SHARE_REQUEST = 7,
    INTRODUCTION = 8,
    ENGAGEMENT = 9,
    LUMI_ASSISTANT = 10,
    CUSTOM = 11,
    ADDITIONAL_SELF = 12,
    STATS = 13,
    WEB_AUTH = 14,
    REVERSE_INDEX = 15,
    GENERIC = 16,
    NEARBY_SHARE = 17,
    NAME_SUGGESTION = 18,
    FB_IMPORT_AUTH = 19,
    SHARE_SELF = 20,
    SHARE_OTHER = 21,
    UNARCHIVE_SUGGESTION = 22,
    GMAIL_PROCESSING_STATUS = 23,
    NAME_COMPLETION = 24,
    NAME_SUGGESTION_DATA = 25,
    UNARCHIVE_SUGGESTION_DATA = 26,
    NAME_COMPLETION_DATA = 27,
    SYNC_USER_STATUS = 28,
    SYNC_ACCOUNT_STATUS = 29
}
export enum TSuggestedSharingInformationType {
    PERSONAL = 0,
    PROFESSIONAL = 1,
    PERSONAL_PROFESSIONAL = 2,
    JUST_ONE = 3
}
export enum TAppDashBoardTimeline {
    UNDEFINED = 0,
    DAY = 1,
    WEEK = 2,
    MONTH = 3,
    LIFETIME = 4
}
export enum TAppEngagementType {
    UNDEFINED = 0,
    LUMI_ASSISTANT = 1,
    GOOGLE_AUTH = 2
}
export enum TAppBlastRequestStatus {
    UNDEFINED = 0,
    PENDING = 1,
    QUEUED = 2,
    SENT = 3,
    FAILED = 4,
    BOUNCED = 5,
    CANCELED = 6,
    REPLIED = 7
}
export interface ITAppEnhancementMetricsArgs {
    enhancedContactCount: number;
    augmentedInfoCount: number;
    markedAsObsoleteCount: number;
    correctedLabelCount: number;
    augmentedFromEmailCount: number;
}
export class TAppEnhancementMetrics {
    public enhancedContactCount: number;
    public augmentedInfoCount: number;
    public markedAsObsoleteCount: number;
    public correctedLabelCount: number;
    public augmentedFromEmailCount: number;
    constructor(args: ITAppEnhancementMetricsArgs) {
        if (args != null && args.enhancedContactCount != null) {
            this.enhancedContactCount = args.enhancedContactCount;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[enhancedContactCount] is unset!");
        }
        if (args != null && args.augmentedInfoCount != null) {
            this.augmentedInfoCount = args.augmentedInfoCount;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[augmentedInfoCount] is unset!");
        }
        if (args != null && args.markedAsObsoleteCount != null) {
            this.markedAsObsoleteCount = args.markedAsObsoleteCount;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[markedAsObsoleteCount] is unset!");
        }
        if (args != null && args.correctedLabelCount != null) {
            this.correctedLabelCount = args.correctedLabelCount;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[correctedLabelCount] is unset!");
        }
        if (args != null && args.augmentedFromEmailCount != null) {
            this.augmentedFromEmailCount = args.augmentedFromEmailCount;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[augmentedFromEmailCount] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppEnhancementMetrics");
        if (this.enhancedContactCount != null) {
            output.writeFieldBegin("enhancedContactCount", thrift.Thrift.Type.I32, 1);
            output.writeI32(this.enhancedContactCount);
            output.writeFieldEnd();
        }
        if (this.augmentedInfoCount != null) {
            output.writeFieldBegin("augmentedInfoCount", thrift.Thrift.Type.I32, 2);
            output.writeI32(this.augmentedInfoCount);
            output.writeFieldEnd();
        }
        if (this.markedAsObsoleteCount != null) {
            output.writeFieldBegin("markedAsObsoleteCount", thrift.Thrift.Type.I32, 3);
            output.writeI32(this.markedAsObsoleteCount);
            output.writeFieldEnd();
        }
        if (this.correctedLabelCount != null) {
            output.writeFieldBegin("correctedLabelCount", thrift.Thrift.Type.I32, 4);
            output.writeI32(this.correctedLabelCount);
            output.writeFieldEnd();
        }
        if (this.augmentedFromEmailCount != null) {
            output.writeFieldBegin("augmentedFromEmailCount", thrift.Thrift.Type.I32, 5);
            output.writeI32(this.augmentedFromEmailCount);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppEnhancementMetrics {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_11: number = input.readI32();
                        _args.enhancedContactCount = value_11;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_12: number = input.readI32();
                        _args.augmentedInfoCount = value_12;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_13: number = input.readI32();
                        _args.markedAsObsoleteCount = value_13;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_14: number = input.readI32();
                        _args.correctedLabelCount = value_14;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_15: number = input.readI32();
                        _args.augmentedFromEmailCount = value_15;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.enhancedContactCount !== undefined && _args.augmentedInfoCount !== undefined && _args.markedAsObsoleteCount !== undefined && _args.correctedLabelCount !== undefined && _args.augmentedFromEmailCount !== undefined) {
            return new TAppEnhancementMetrics(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppEnhancementMetrics from input");
        }
    }
}
export interface ITAppWelcomeDataArgs {
    appleImportCount: string;
    googleImportCount: string;
    executedMergeCount: string;
    enhancementMetrics: TAppEnhancementMetrics;
}
export class TAppWelcomeData {
    public appleImportCount: string;
    public googleImportCount: string;
    public executedMergeCount: string;
    public enhancementMetrics: TAppEnhancementMetrics;
    constructor(args: ITAppWelcomeDataArgs) {
        if (args != null && args.appleImportCount != null) {
            this.appleImportCount = args.appleImportCount;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[appleImportCount] is unset!");
        }
        if (args != null && args.googleImportCount != null) {
            this.googleImportCount = args.googleImportCount;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[googleImportCount] is unset!");
        }
        if (args != null && args.executedMergeCount != null) {
            this.executedMergeCount = args.executedMergeCount;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[executedMergeCount] is unset!");
        }
        if (args != null && args.enhancementMetrics != null) {
            this.enhancementMetrics = args.enhancementMetrics;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[enhancementMetrics] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppWelcomeData");
        if (this.appleImportCount != null) {
            output.writeFieldBegin("appleImportCount", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.appleImportCount);
            output.writeFieldEnd();
        }
        if (this.googleImportCount != null) {
            output.writeFieldBegin("googleImportCount", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.googleImportCount);
            output.writeFieldEnd();
        }
        if (this.executedMergeCount != null) {
            output.writeFieldBegin("executedMergeCount", thrift.Thrift.Type.STRING, 3);
            output.writeString(this.executedMergeCount);
            output.writeFieldEnd();
        }
        if (this.enhancementMetrics != null) {
            output.writeFieldBegin("enhancementMetrics", thrift.Thrift.Type.STRUCT, 4);
            this.enhancementMetrics.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppWelcomeData {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_16: string = input.readString();
                        _args.appleImportCount = value_16;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_17: string = input.readString();
                        _args.googleImportCount = value_17;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_18: string = input.readString();
                        _args.executedMergeCount = value_18;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_19: TAppEnhancementMetrics = TAppEnhancementMetrics.read(input);
                        _args.enhancementMetrics = value_19;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.appleImportCount !== undefined && _args.googleImportCount !== undefined && _args.executedMergeCount !== undefined && _args.enhancementMetrics !== undefined) {
            return new TAppWelcomeData(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppWelcomeData from input");
        }
    }
}
export interface ITAppDashboardDataArgs {
    timeline: TAppDashBoardTimeline;
    enhancementMetrics: TAppEnhancementMetrics;
}
export class TAppDashboardData {
    public timeline: TAppDashBoardTimeline;
    public enhancementMetrics: TAppEnhancementMetrics;
    constructor(args: ITAppDashboardDataArgs) {
        if (args != null && args.timeline != null) {
            this.timeline = args.timeline;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[timeline] is unset!");
        }
        if (args != null && args.enhancementMetrics != null) {
            this.enhancementMetrics = args.enhancementMetrics;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[enhancementMetrics] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppDashboardData");
        if (this.timeline != null) {
            output.writeFieldBegin("timeline", thrift.Thrift.Type.I32, 1);
            output.writeI32(this.timeline);
            output.writeFieldEnd();
        }
        if (this.enhancementMetrics != null) {
            output.writeFieldBegin("enhancementMetrics", thrift.Thrift.Type.STRUCT, 2);
            this.enhancementMetrics.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppDashboardData {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_20: TAppDashBoardTimeline = input.readI32();
                        _args.timeline = value_20;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_21: TAppEnhancementMetrics = TAppEnhancementMetrics.read(input);
                        _args.enhancementMetrics = value_21;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.timeline !== undefined && _args.enhancementMetrics !== undefined) {
            return new TAppDashboardData(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppDashboardData from input");
        }
    }
}
export interface ITAppTopContactArgs {
    contactId: string;
    ranking?: number;
}
export class TAppTopContact {
    public contactId: string;
    public ranking?: number;
    constructor(args: ITAppTopContactArgs) {
        if (args != null && args.contactId != null) {
            this.contactId = args.contactId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[contactId] is unset!");
        }
        if (args != null && args.ranking != null) {
            this.ranking = args.ranking;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppTopContact");
        if (this.contactId != null) {
            output.writeFieldBegin("contactId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.contactId);
            output.writeFieldEnd();
        }
        if (this.ranking != null) {
            output.writeFieldBegin("ranking", thrift.Thrift.Type.DOUBLE, 2);
            output.writeDouble(this.ranking);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppTopContact {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_22: string = input.readString();
                        _args.contactId = value_22;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.DOUBLE) {
                        const value_23: number = input.readDouble();
                        _args.ranking = value_23;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.contactId !== undefined) {
            return new TAppTopContact(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppTopContact from input");
        }
    }
}
export interface ITAppTopContactsDataArgs {
    topContacts?: Array<TAppTopContact>;
    suggestedTopContacts?: Array<TAppTopContact>;
}
export class TAppTopContactsData {
    public topContacts?: Array<TAppTopContact>;
    public suggestedTopContacts?: Array<TAppTopContact>;
    constructor(args?: ITAppTopContactsDataArgs) {
        if (args != null && args.topContacts != null) {
            this.topContacts = args.topContacts;
        }
        if (args != null && args.suggestedTopContacts != null) {
            this.suggestedTopContacts = args.suggestedTopContacts;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppTopContactsData");
        if (this.topContacts != null) {
            output.writeFieldBegin("topContacts", thrift.Thrift.Type.LIST, 1);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.topContacts.length);
            this.topContacts.forEach((value_24: TAppTopContact): void => {
                value_24.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.suggestedTopContacts != null) {
            output.writeFieldBegin("suggestedTopContacts", thrift.Thrift.Type.LIST, 2);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.suggestedTopContacts.length);
            this.suggestedTopContacts.forEach((value_25: TAppTopContact): void => {
                value_25.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppTopContactsData {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_26: Array<TAppTopContact> = new Array<TAppTopContact>();
                        const metadata_2: thrift.TList = input.readListBegin();
                        const size_2: number = metadata_2.size;
                        for (let i_2: number = 0; i_2 < size_2; i_2++) {
                            const value_27: TAppTopContact = TAppTopContact.read(input);
                            value_26.push(value_27);
                        }
                        input.readListEnd();
                        _args.topContacts = value_26;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_28: Array<TAppTopContact> = new Array<TAppTopContact>();
                        const metadata_3: thrift.TList = input.readListBegin();
                        const size_3: number = metadata_3.size;
                        for (let i_3: number = 0; i_3 < size_3; i_3++) {
                            const value_29: TAppTopContact = TAppTopContact.read(input);
                            value_28.push(value_29);
                        }
                        input.readListEnd();
                        _args.suggestedTopContacts = value_28;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppTopContactsData(_args);
    }
}
export interface ITAppNearbyDataArgs {
}
export class TAppNearbyData {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppNearbyData");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppNearbyData {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppNearbyData();
    }
}
export interface ITAppBirthdayContactArgs {
    contactId: string;
    birthday: PContact.TAppDate;
}
export class TAppBirthdayContact {
    public contactId: string;
    public birthday: PContact.TAppDate;
    constructor(args: ITAppBirthdayContactArgs) {
        if (args != null && args.contactId != null) {
            this.contactId = args.contactId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[contactId] is unset!");
        }
        if (args != null && args.birthday != null) {
            this.birthday = args.birthday;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[birthday] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppBirthdayContact");
        if (this.contactId != null) {
            output.writeFieldBegin("contactId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.contactId);
            output.writeFieldEnd();
        }
        if (this.birthday != null) {
            output.writeFieldBegin("birthday", thrift.Thrift.Type.STRUCT, 2);
            this.birthday.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppBirthdayContact {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_30: string = input.readString();
                        _args.contactId = value_30;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_31: PContact.TAppDate = PContact.TAppDate.read(input);
                        _args.birthday = value_31;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.contactId !== undefined && _args.birthday !== undefined) {
            return new TAppBirthdayContact(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppBirthdayContact from input");
        }
    }
}
export interface ITAppBirthdayDataArgs {
    orderedBirthdays: Array<TAppBirthdayContact>;
}
export class TAppBirthdayData {
    public orderedBirthdays: Array<TAppBirthdayContact>;
    constructor(args: ITAppBirthdayDataArgs) {
        if (args != null && args.orderedBirthdays != null) {
            this.orderedBirthdays = args.orderedBirthdays;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[orderedBirthdays] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppBirthdayData");
        if (this.orderedBirthdays != null) {
            output.writeFieldBegin("orderedBirthdays", thrift.Thrift.Type.LIST, 1);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.orderedBirthdays.length);
            this.orderedBirthdays.forEach((value_32: TAppBirthdayContact): void => {
                value_32.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppBirthdayData {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_33: Array<TAppBirthdayContact> = new Array<TAppBirthdayContact>();
                        const metadata_4: thrift.TList = input.readListBegin();
                        const size_4: number = metadata_4.size;
                        for (let i_4: number = 0; i_4 < size_4; i_4++) {
                            const value_34: TAppBirthdayContact = TAppBirthdayContact.read(input);
                            value_33.push(value_34);
                        }
                        input.readListEnd();
                        _args.orderedBirthdays = value_33;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.orderedBirthdays !== undefined) {
            return new TAppBirthdayData(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppBirthdayData from input");
        }
    }
}
export interface ITAppMergeSuggestionArgs {
    mergeSuggestionId: string;
    contactIds: Array<string>;
    appContact1: PContact.TAppContact;
    appContact2: PContact.TAppContact;
}
export class TAppMergeSuggestion {
    public mergeSuggestionId: string;
    public contactIds: Array<string>;
    public appContact1: PContact.TAppContact;
    public appContact2: PContact.TAppContact;
    constructor(args: ITAppMergeSuggestionArgs) {
        if (args != null && args.mergeSuggestionId != null) {
            this.mergeSuggestionId = args.mergeSuggestionId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[mergeSuggestionId] is unset!");
        }
        if (args != null && args.contactIds != null) {
            this.contactIds = args.contactIds;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[contactIds] is unset!");
        }
        if (args != null && args.appContact1 != null) {
            this.appContact1 = args.appContact1;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[appContact1] is unset!");
        }
        if (args != null && args.appContact2 != null) {
            this.appContact2 = args.appContact2;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[appContact2] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppMergeSuggestion");
        if (this.mergeSuggestionId != null) {
            output.writeFieldBegin("mergeSuggestionId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.mergeSuggestionId);
            output.writeFieldEnd();
        }
        if (this.contactIds != null) {
            output.writeFieldBegin("contactIds", thrift.Thrift.Type.LIST, 2);
            output.writeListBegin(thrift.Thrift.Type.STRING, this.contactIds.length);
            this.contactIds.forEach((value_35: string): void => {
                output.writeString(value_35);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.appContact1 != null) {
            output.writeFieldBegin("appContact1", thrift.Thrift.Type.STRUCT, 3);
            this.appContact1.write(output);
            output.writeFieldEnd();
        }
        if (this.appContact2 != null) {
            output.writeFieldBegin("appContact2", thrift.Thrift.Type.STRUCT, 4);
            this.appContact2.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppMergeSuggestion {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_36: string = input.readString();
                        _args.mergeSuggestionId = value_36;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_37: Array<string> = new Array<string>();
                        const metadata_5: thrift.TList = input.readListBegin();
                        const size_5: number = metadata_5.size;
                        for (let i_5: number = 0; i_5 < size_5; i_5++) {
                            const value_38: string = input.readString();
                            value_37.push(value_38);
                        }
                        input.readListEnd();
                        _args.contactIds = value_37;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_39: PContact.TAppContact = PContact.TAppContact.read(input);
                        _args.appContact1 = value_39;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_40: PContact.TAppContact = PContact.TAppContact.read(input);
                        _args.appContact2 = value_40;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.mergeSuggestionId !== undefined && _args.contactIds !== undefined && _args.appContact1 !== undefined && _args.appContact2 !== undefined) {
            return new TAppMergeSuggestion(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppMergeSuggestion from input");
        }
    }
}
export interface ITAppMergeConfirmationDataArgs {
    mergeSuggestions: Array<TAppMergeSuggestion>;
    totalPendingCount?: number;
    displayString?: string;
}
export class TAppMergeConfirmationData {
    public mergeSuggestions: Array<TAppMergeSuggestion>;
    public totalPendingCount?: number;
    public displayString?: string;
    constructor(args: ITAppMergeConfirmationDataArgs) {
        if (args != null && args.mergeSuggestions != null) {
            this.mergeSuggestions = args.mergeSuggestions;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[mergeSuggestions] is unset!");
        }
        if (args != null && args.totalPendingCount != null) {
            this.totalPendingCount = args.totalPendingCount;
        }
        if (args != null && args.displayString != null) {
            this.displayString = args.displayString;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppMergeConfirmationData");
        if (this.mergeSuggestions != null) {
            output.writeFieldBegin("mergeSuggestions", thrift.Thrift.Type.LIST, 1);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.mergeSuggestions.length);
            this.mergeSuggestions.forEach((value_41: TAppMergeSuggestion): void => {
                value_41.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.totalPendingCount != null) {
            output.writeFieldBegin("totalPendingCount", thrift.Thrift.Type.I16, 2);
            output.writeI16(this.totalPendingCount);
            output.writeFieldEnd();
        }
        if (this.displayString != null) {
            output.writeFieldBegin("displayString", thrift.Thrift.Type.STRING, 3);
            output.writeString(this.displayString);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppMergeConfirmationData {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_42: Array<TAppMergeSuggestion> = new Array<TAppMergeSuggestion>();
                        const metadata_6: thrift.TList = input.readListBegin();
                        const size_6: number = metadata_6.size;
                        for (let i_6: number = 0; i_6 < size_6; i_6++) {
                            const value_43: TAppMergeSuggestion = TAppMergeSuggestion.read(input);
                            value_42.push(value_43);
                        }
                        input.readListEnd();
                        _args.mergeSuggestions = value_42;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.I16) {
                        const value_44: number = input.readI16();
                        _args.totalPendingCount = value_44;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_45: string = input.readString();
                        _args.displayString = value_45;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.mergeSuggestions !== undefined) {
            return new TAppMergeConfirmationData(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppMergeConfirmationData from input");
        }
    }
}
export interface ITAppShareRequestContactArgs {
    contact: PContact.TAppContact;
    isShared: boolean;
    notificationDataId: string;
    userId?: string;
    isShareBackVisible?: boolean;
}
export class TAppShareRequestContact {
    public contact: PContact.TAppContact;
    public isShared: boolean;
    public notificationDataId: string;
    public userId?: string;
    public isShareBackVisible?: boolean;
    constructor(args: ITAppShareRequestContactArgs) {
        if (args != null && args.contact != null) {
            this.contact = args.contact;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[contact] is unset!");
        }
        if (args != null && args.isShared != null) {
            this.isShared = args.isShared;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[isShared] is unset!");
        }
        if (args != null && args.notificationDataId != null) {
            this.notificationDataId = args.notificationDataId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[notificationDataId] is unset!");
        }
        if (args != null && args.userId != null) {
            this.userId = args.userId;
        }
        if (args != null && args.isShareBackVisible != null) {
            this.isShareBackVisible = args.isShareBackVisible;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppShareRequestContact");
        if (this.contact != null) {
            output.writeFieldBegin("contact", thrift.Thrift.Type.STRUCT, 1);
            this.contact.write(output);
            output.writeFieldEnd();
        }
        if (this.isShared != null) {
            output.writeFieldBegin("isShared", thrift.Thrift.Type.BOOL, 2);
            output.writeBool(this.isShared);
            output.writeFieldEnd();
        }
        if (this.notificationDataId != null) {
            output.writeFieldBegin("notificationDataId", thrift.Thrift.Type.STRING, 3);
            output.writeString(this.notificationDataId);
            output.writeFieldEnd();
        }
        if (this.userId != null) {
            output.writeFieldBegin("userId", thrift.Thrift.Type.STRING, 4);
            output.writeString(this.userId);
            output.writeFieldEnd();
        }
        if (this.isShareBackVisible != null) {
            output.writeFieldBegin("isShareBackVisible", thrift.Thrift.Type.BOOL, 5);
            output.writeBool(this.isShareBackVisible);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppShareRequestContact {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_46: PContact.TAppContact = PContact.TAppContact.read(input);
                        _args.contact = value_46;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_47: boolean = input.readBool();
                        _args.isShared = value_47;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_48: string = input.readString();
                        _args.notificationDataId = value_48;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_49: string = input.readString();
                        _args.userId = value_49;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_50: boolean = input.readBool();
                        _args.isShareBackVisible = value_50;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.contact !== undefined && _args.isShared !== undefined && _args.notificationDataId !== undefined) {
            return new TAppShareRequestContact(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppShareRequestContact from input");
        }
    }
}
export interface ITAppShareRequestDataArgs {
    shareRequestList: Array<TAppShareRequestContact>;
}
export class TAppShareRequestData {
    public shareRequestList: Array<TAppShareRequestContact>;
    constructor(args: ITAppShareRequestDataArgs) {
        if (args != null && args.shareRequestList != null) {
            this.shareRequestList = args.shareRequestList;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[shareRequestList] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppShareRequestData");
        if (this.shareRequestList != null) {
            output.writeFieldBegin("shareRequestList", thrift.Thrift.Type.LIST, 1);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.shareRequestList.length);
            this.shareRequestList.forEach((value_51: TAppShareRequestContact): void => {
                value_51.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppShareRequestData {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_52: Array<TAppShareRequestContact> = new Array<TAppShareRequestContact>();
                        const metadata_7: thrift.TList = input.readListBegin();
                        const size_7: number = metadata_7.size;
                        for (let i_7: number = 0; i_7 < size_7; i_7++) {
                            const value_53: TAppShareRequestContact = TAppShareRequestContact.read(input);
                            value_52.push(value_53);
                        }
                        input.readListEnd();
                        _args.shareRequestList = value_52;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.shareRequestList !== undefined) {
            return new TAppShareRequestData(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppShareRequestData from input");
        }
    }
}
export interface ITAppIntroductionContactArgs {
    sourceContact: PContact.TAppContact;
    sharedContact: PContact.TAppContact;
    notificationDataId: string;
    isFromMakeAnIntro?: boolean;
    isShareBackVisible?: boolean;
}
export class TAppIntroductionContact {
    public sourceContact: PContact.TAppContact;
    public sharedContact: PContact.TAppContact;
    public notificationDataId: string;
    public isFromMakeAnIntro?: boolean;
    public isShareBackVisible?: boolean;
    constructor(args: ITAppIntroductionContactArgs) {
        if (args != null && args.sourceContact != null) {
            this.sourceContact = args.sourceContact;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[sourceContact] is unset!");
        }
        if (args != null && args.sharedContact != null) {
            this.sharedContact = args.sharedContact;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[sharedContact] is unset!");
        }
        if (args != null && args.notificationDataId != null) {
            this.notificationDataId = args.notificationDataId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[notificationDataId] is unset!");
        }
        if (args != null && args.isFromMakeAnIntro != null) {
            this.isFromMakeAnIntro = args.isFromMakeAnIntro;
        }
        if (args != null && args.isShareBackVisible != null) {
            this.isShareBackVisible = args.isShareBackVisible;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppIntroductionContact");
        if (this.sourceContact != null) {
            output.writeFieldBegin("sourceContact", thrift.Thrift.Type.STRUCT, 1);
            this.sourceContact.write(output);
            output.writeFieldEnd();
        }
        if (this.sharedContact != null) {
            output.writeFieldBegin("sharedContact", thrift.Thrift.Type.STRUCT, 2);
            this.sharedContact.write(output);
            output.writeFieldEnd();
        }
        if (this.notificationDataId != null) {
            output.writeFieldBegin("notificationDataId", thrift.Thrift.Type.STRING, 3);
            output.writeString(this.notificationDataId);
            output.writeFieldEnd();
        }
        if (this.isFromMakeAnIntro != null) {
            output.writeFieldBegin("isFromMakeAnIntro", thrift.Thrift.Type.BOOL, 4);
            output.writeBool(this.isFromMakeAnIntro);
            output.writeFieldEnd();
        }
        if (this.isShareBackVisible != null) {
            output.writeFieldBegin("isShareBackVisible", thrift.Thrift.Type.BOOL, 5);
            output.writeBool(this.isShareBackVisible);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppIntroductionContact {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_54: PContact.TAppContact = PContact.TAppContact.read(input);
                        _args.sourceContact = value_54;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_55: PContact.TAppContact = PContact.TAppContact.read(input);
                        _args.sharedContact = value_55;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_56: string = input.readString();
                        _args.notificationDataId = value_56;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_57: boolean = input.readBool();
                        _args.isFromMakeAnIntro = value_57;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_58: boolean = input.readBool();
                        _args.isShareBackVisible = value_58;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.sourceContact !== undefined && _args.sharedContact !== undefined && _args.notificationDataId !== undefined) {
            return new TAppIntroductionContact(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppIntroductionContact from input");
        }
    }
}
export interface ITAppIntroductionDataArgs {
    introductions?: Array<TAppIntroductionContact>;
}
export class TAppIntroductionData {
    public introductions?: Array<TAppIntroductionContact>;
    constructor(args?: ITAppIntroductionDataArgs) {
        if (args != null && args.introductions != null) {
            this.introductions = args.introductions;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppIntroductionData");
        if (this.introductions != null) {
            output.writeFieldBegin("introductions", thrift.Thrift.Type.LIST, 1);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.introductions.length);
            this.introductions.forEach((value_59: TAppIntroductionContact): void => {
                value_59.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppIntroductionData {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_60: Array<TAppIntroductionContact> = new Array<TAppIntroductionContact>();
                        const metadata_8: thrift.TList = input.readListBegin();
                        const size_8: number = metadata_8.size;
                        for (let i_8: number = 0; i_8 < size_8; i_8++) {
                            const value_61: TAppIntroductionContact = TAppIntroductionContact.read(input);
                            value_60.push(value_61);
                        }
                        input.readListEnd();
                        _args.introductions = value_60;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppIntroductionData(_args);
    }
}
export interface ITAppSingleIntroductionDataArgs {
    senderContact: PContact.TAppContact;
    sharedContact: PContact.TAppContact;
}
export class TAppSingleIntroductionData {
    public senderContact: PContact.TAppContact;
    public sharedContact: PContact.TAppContact;
    constructor(args: ITAppSingleIntroductionDataArgs) {
        if (args != null && args.senderContact != null) {
            this.senderContact = args.senderContact;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[senderContact] is unset!");
        }
        if (args != null && args.sharedContact != null) {
            this.sharedContact = args.sharedContact;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[sharedContact] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppSingleIntroductionData");
        if (this.senderContact != null) {
            output.writeFieldBegin("senderContact", thrift.Thrift.Type.STRUCT, 1);
            this.senderContact.write(output);
            output.writeFieldEnd();
        }
        if (this.sharedContact != null) {
            output.writeFieldBegin("sharedContact", thrift.Thrift.Type.STRUCT, 2);
            this.sharedContact.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppSingleIntroductionData {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_62: PContact.TAppContact = PContact.TAppContact.read(input);
                        _args.senderContact = value_62;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_63: PContact.TAppContact = PContact.TAppContact.read(input);
                        _args.sharedContact = value_63;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.senderContact !== undefined && _args.sharedContact !== undefined) {
            return new TAppSingleIntroductionData(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppSingleIntroductionData from input");
        }
    }
}
export interface ITAppEngagementArgs {
    engagementType: TAppEngagementType;
    priority: number;
    customMessage?: string;
}
export class TAppEngagement {
    public engagementType: TAppEngagementType;
    public priority: number;
    public customMessage?: string;
    constructor(args: ITAppEngagementArgs) {
        if (args != null && args.engagementType != null) {
            this.engagementType = args.engagementType;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[engagementType] is unset!");
        }
        if (args != null && args.priority != null) {
            this.priority = args.priority;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[priority] is unset!");
        }
        if (args != null && args.customMessage != null) {
            this.customMessage = args.customMessage;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppEngagement");
        if (this.engagementType != null) {
            output.writeFieldBegin("engagementType", thrift.Thrift.Type.I32, 1);
            output.writeI32(this.engagementType);
            output.writeFieldEnd();
        }
        if (this.priority != null) {
            output.writeFieldBegin("priority", thrift.Thrift.Type.I32, 2);
            output.writeI32(this.priority);
            output.writeFieldEnd();
        }
        if (this.customMessage != null) {
            output.writeFieldBegin("customMessage", thrift.Thrift.Type.STRING, 3);
            output.writeString(this.customMessage);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppEngagement {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_64: TAppEngagementType = input.readI32();
                        _args.engagementType = value_64;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_65: number = input.readI32();
                        _args.priority = value_65;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_66: string = input.readString();
                        _args.customMessage = value_66;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.engagementType !== undefined && _args.priority !== undefined) {
            return new TAppEngagement(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppEngagement from input");
        }
    }
}
export interface ITAppEngagementDataArgs {
    engagements: Array<TAppEngagement>;
}
export class TAppEngagementData {
    public engagements: Array<TAppEngagement>;
    constructor(args: ITAppEngagementDataArgs) {
        if (args != null && args.engagements != null) {
            this.engagements = args.engagements;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[engagements] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppEngagementData");
        if (this.engagements != null) {
            output.writeFieldBegin("engagements", thrift.Thrift.Type.LIST, 1);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.engagements.length);
            this.engagements.forEach((value_67: TAppEngagement): void => {
                value_67.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppEngagementData {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_68: Array<TAppEngagement> = new Array<TAppEngagement>();
                        const metadata_9: thrift.TList = input.readListBegin();
                        const size_9: number = metadata_9.size;
                        for (let i_9: number = 0; i_9 < size_9; i_9++) {
                            const value_69: TAppEngagement = TAppEngagement.read(input);
                            value_68.push(value_69);
                        }
                        input.readListEnd();
                        _args.engagements = value_68;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.engagements !== undefined) {
            return new TAppEngagementData(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppEngagementData from input");
        }
    }
}
export interface ITAppLumiAssistantDataArgs {
    statusCount: Map<TAppBlastRequestStatus, number>;
    isComplete: boolean;
    isPaused: boolean;
    blastUrl?: string;
}
export class TAppLumiAssistantData {
    public statusCount: Map<TAppBlastRequestStatus, number>;
    public isComplete: boolean;
    public isPaused: boolean;
    public blastUrl?: string;
    constructor(args: ITAppLumiAssistantDataArgs) {
        if (args != null && args.statusCount != null) {
            this.statusCount = args.statusCount;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[statusCount] is unset!");
        }
        if (args != null && args.isComplete != null) {
            this.isComplete = args.isComplete;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[isComplete] is unset!");
        }
        if (args != null && args.isPaused != null) {
            this.isPaused = args.isPaused;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[isPaused] is unset!");
        }
        if (args != null && args.blastUrl != null) {
            this.blastUrl = args.blastUrl;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppLumiAssistantData");
        if (this.statusCount != null) {
            output.writeFieldBegin("statusCount", thrift.Thrift.Type.MAP, 1);
            output.writeMapBegin(thrift.Thrift.Type.I32, thrift.Thrift.Type.I32, this.statusCount.size);
            this.statusCount.forEach((value_70: number, key_1: TAppBlastRequestStatus): void => {
                output.writeI32(key_1);
                output.writeI32(value_70);
            });
            output.writeMapEnd();
            output.writeFieldEnd();
        }
        if (this.isComplete != null) {
            output.writeFieldBegin("isComplete", thrift.Thrift.Type.BOOL, 2);
            output.writeBool(this.isComplete);
            output.writeFieldEnd();
        }
        if (this.isPaused != null) {
            output.writeFieldBegin("isPaused", thrift.Thrift.Type.BOOL, 3);
            output.writeBool(this.isPaused);
            output.writeFieldEnd();
        }
        if (this.blastUrl != null) {
            output.writeFieldBegin("blastUrl", thrift.Thrift.Type.STRING, 4);
            output.writeString(this.blastUrl);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppLumiAssistantData {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.MAP) {
                        const value_71: Map<TAppBlastRequestStatus, number> = new Map<TAppBlastRequestStatus, number>();
                        const metadata_10: thrift.TMap = input.readMapBegin();
                        const size_10: number = metadata_10.size;
                        for (let i_10: number = 0; i_10 < size_10; i_10++) {
                            const key_2: TAppBlastRequestStatus = input.readI32();
                            const value_72: number = input.readI32();
                            value_71.set(key_2, value_72);
                        }
                        input.readMapEnd();
                        _args.statusCount = value_71;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_73: boolean = input.readBool();
                        _args.isComplete = value_73;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_74: boolean = input.readBool();
                        _args.isPaused = value_74;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_75: string = input.readString();
                        _args.blastUrl = value_75;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.statusCount !== undefined && _args.isComplete !== undefined && _args.isPaused !== undefined) {
            return new TAppLumiAssistantData(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppLumiAssistantData from input");
        }
    }
}
export interface ITAppCustomDataArgs {
    title?: string;
    message?: string;
    iconURL?: string;
    link?: string;
    linkDisplayText?: string;
}
export class TAppCustomData {
    public title?: string;
    public message?: string;
    public iconURL?: string;
    public link?: string;
    public linkDisplayText?: string;
    constructor(args?: ITAppCustomDataArgs) {
        if (args != null && args.title != null) {
            this.title = args.title;
        }
        if (args != null && args.message != null) {
            this.message = args.message;
        }
        if (args != null && args.iconURL != null) {
            this.iconURL = args.iconURL;
        }
        if (args != null && args.link != null) {
            this.link = args.link;
        }
        if (args != null && args.linkDisplayText != null) {
            this.linkDisplayText = args.linkDisplayText;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppCustomData");
        if (this.title != null) {
            output.writeFieldBegin("title", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.title);
            output.writeFieldEnd();
        }
        if (this.message != null) {
            output.writeFieldBegin("message", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.message);
            output.writeFieldEnd();
        }
        if (this.iconURL != null) {
            output.writeFieldBegin("iconURL", thrift.Thrift.Type.STRING, 3);
            output.writeString(this.iconURL);
            output.writeFieldEnd();
        }
        if (this.link != null) {
            output.writeFieldBegin("link", thrift.Thrift.Type.STRING, 4);
            output.writeString(this.link);
            output.writeFieldEnd();
        }
        if (this.linkDisplayText != null) {
            output.writeFieldBegin("linkDisplayText", thrift.Thrift.Type.STRING, 5);
            output.writeString(this.linkDisplayText);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppCustomData {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_76: string = input.readString();
                        _args.title = value_76;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_77: string = input.readString();
                        _args.message = value_77;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_78: string = input.readString();
                        _args.iconURL = value_78;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_79: string = input.readString();
                        _args.link = value_79;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_80: string = input.readString();
                        _args.linkDisplayText = value_80;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppCustomData(_args);
    }
}
export interface ITAppAdditionalSelfContactDataArgs {
    additionalSelfContactInfo?: Array<PContact.TAppContact>;
}
export class TAppAdditionalSelfContactData {
    public additionalSelfContactInfo?: Array<PContact.TAppContact>;
    constructor(args?: ITAppAdditionalSelfContactDataArgs) {
        if (args != null && args.additionalSelfContactInfo != null) {
            this.additionalSelfContactInfo = args.additionalSelfContactInfo;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppAdditionalSelfContactData");
        if (this.additionalSelfContactInfo != null) {
            output.writeFieldBegin("additionalSelfContactInfo", thrift.Thrift.Type.LIST, 1);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.additionalSelfContactInfo.length);
            this.additionalSelfContactInfo.forEach((value_81: PContact.TAppContact): void => {
                value_81.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppAdditionalSelfContactData {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_82: Array<PContact.TAppContact> = new Array<PContact.TAppContact>();
                        const metadata_11: thrift.TList = input.readListBegin();
                        const size_11: number = metadata_11.size;
                        for (let i_11: number = 0; i_11 < size_11; i_11++) {
                            const value_83: PContact.TAppContact = PContact.TAppContact.read(input);
                            value_82.push(value_83);
                        }
                        input.readListEnd();
                        _args.additionalSelfContactInfo = value_82;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppAdditionalSelfContactData(_args);
    }
}
export interface ITAppIsThisYouDataArgs {
    additionalSelfContactInfo: PContact.TAppContact;
}
export class TAppIsThisYouData {
    public additionalSelfContactInfo: PContact.TAppContact;
    constructor(args: ITAppIsThisYouDataArgs) {
        if (args != null && args.additionalSelfContactInfo != null) {
            this.additionalSelfContactInfo = args.additionalSelfContactInfo;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[additionalSelfContactInfo] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppIsThisYouData");
        if (this.additionalSelfContactInfo != null) {
            output.writeFieldBegin("additionalSelfContactInfo", thrift.Thrift.Type.STRUCT, 1);
            this.additionalSelfContactInfo.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppIsThisYouData {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_84: PContact.TAppContact = PContact.TAppContact.read(input);
                        _args.additionalSelfContactInfo = value_84;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.additionalSelfContactInfo !== undefined) {
            return new TAppIsThisYouData(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppIsThisYouData from input");
        }
    }
}
export interface ITAppStatsDataArgs {
    total?: number;
    improvedContactsCount?: number;
    improvedFieldsCount?: number;
}
export class TAppStatsData {
    public total?: number;
    public improvedContactsCount?: number;
    public improvedFieldsCount?: number;
    constructor(args?: ITAppStatsDataArgs) {
        if (args != null && args.total != null) {
            this.total = args.total;
        }
        if (args != null && args.improvedContactsCount != null) {
            this.improvedContactsCount = args.improvedContactsCount;
        }
        if (args != null && args.improvedFieldsCount != null) {
            this.improvedFieldsCount = args.improvedFieldsCount;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppStatsData");
        if (this.total != null) {
            output.writeFieldBegin("total", thrift.Thrift.Type.I32, 10);
            output.writeI32(this.total);
            output.writeFieldEnd();
        }
        if (this.improvedContactsCount != null) {
            output.writeFieldBegin("improvedContactsCount", thrift.Thrift.Type.I32, 11);
            output.writeI32(this.improvedContactsCount);
            output.writeFieldEnd();
        }
        if (this.improvedFieldsCount != null) {
            output.writeFieldBegin("improvedFieldsCount", thrift.Thrift.Type.I32, 12);
            output.writeI32(this.improvedFieldsCount);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppStatsData {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 10:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_85: number = input.readI32();
                        _args.total = value_85;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 11:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_86: number = input.readI32();
                        _args.improvedContactsCount = value_86;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 12:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_87: number = input.readI32();
                        _args.improvedFieldsCount = value_87;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppStatsData(_args);
    }
}
export interface ITAppWebAuthDataArgs {
    request?: Authenticate.TWebAuthenticateRequest;
}
export class TAppWebAuthData {
    public request?: Authenticate.TWebAuthenticateRequest;
    constructor(args?: ITAppWebAuthDataArgs) {
        if (args != null && args.request != null) {
            this.request = args.request;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppWebAuthData");
        if (this.request != null) {
            output.writeFieldBegin("request", thrift.Thrift.Type.STRUCT, 1);
            this.request.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppWebAuthData {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_88: Authenticate.TWebAuthenticateRequest = Authenticate.TWebAuthenticateRequest.read(input);
                        _args.request = value_88;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppWebAuthData(_args);
    }
}
export interface ITAppReverseIndexSuggestedShareArgs {
    sourceContactId?: string;
    destinationContactId?: string;
    aclId?: string;
    shareType?: TSuggestedSharingInformationType;
    appContact?: PContact.TAppContact;
}
export class TAppReverseIndexSuggestedShare {
    public sourceContactId?: string;
    public destinationContactId?: string;
    public aclId?: string;
    public shareType?: TSuggestedSharingInformationType;
    public appContact?: PContact.TAppContact;
    constructor(args?: ITAppReverseIndexSuggestedShareArgs) {
        if (args != null && args.sourceContactId != null) {
            this.sourceContactId = args.sourceContactId;
        }
        if (args != null && args.destinationContactId != null) {
            this.destinationContactId = args.destinationContactId;
        }
        if (args != null && args.aclId != null) {
            this.aclId = args.aclId;
        }
        if (args != null && args.shareType != null) {
            this.shareType = args.shareType;
        }
        if (args != null && args.appContact != null) {
            this.appContact = args.appContact;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppReverseIndexSuggestedShare");
        if (this.sourceContactId != null) {
            output.writeFieldBegin("sourceContactId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.sourceContactId);
            output.writeFieldEnd();
        }
        if (this.destinationContactId != null) {
            output.writeFieldBegin("destinationContactId", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.destinationContactId);
            output.writeFieldEnd();
        }
        if (this.aclId != null) {
            output.writeFieldBegin("aclId", thrift.Thrift.Type.STRING, 3);
            output.writeString(this.aclId);
            output.writeFieldEnd();
        }
        if (this.shareType != null) {
            output.writeFieldBegin("shareType", thrift.Thrift.Type.I32, 4);
            output.writeI32(this.shareType);
            output.writeFieldEnd();
        }
        if (this.appContact != null) {
            output.writeFieldBegin("appContact", thrift.Thrift.Type.STRUCT, 5);
            this.appContact.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppReverseIndexSuggestedShare {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_89: string = input.readString();
                        _args.sourceContactId = value_89;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_90: string = input.readString();
                        _args.destinationContactId = value_90;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_91: string = input.readString();
                        _args.aclId = value_91;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_92: TSuggestedSharingInformationType = input.readI32();
                        _args.shareType = value_92;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_93: PContact.TAppContact = PContact.TAppContact.read(input);
                        _args.appContact = value_93;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppReverseIndexSuggestedShare(_args);
    }
}
export interface ITAppReverseIndexSuggestedShareDataArgs {
    suggestedShares?: Array<TAppReverseIndexSuggestedShare>;
    displayString?: string;
}
export class TAppReverseIndexSuggestedShareData {
    public suggestedShares?: Array<TAppReverseIndexSuggestedShare>;
    public displayString?: string;
    constructor(args?: ITAppReverseIndexSuggestedShareDataArgs) {
        if (args != null && args.suggestedShares != null) {
            this.suggestedShares = args.suggestedShares;
        }
        if (args != null && args.displayString != null) {
            this.displayString = args.displayString;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppReverseIndexSuggestedShareData");
        if (this.suggestedShares != null) {
            output.writeFieldBegin("suggestedShares", thrift.Thrift.Type.LIST, 1);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.suggestedShares.length);
            this.suggestedShares.forEach((value_94: TAppReverseIndexSuggestedShare): void => {
                value_94.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.displayString != null) {
            output.writeFieldBegin("displayString", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.displayString);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppReverseIndexSuggestedShareData {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_95: Array<TAppReverseIndexSuggestedShare> = new Array<TAppReverseIndexSuggestedShare>();
                        const metadata_12: thrift.TList = input.readListBegin();
                        const size_12: number = metadata_12.size;
                        for (let i_12: number = 0; i_12 < size_12; i_12++) {
                            const value_96: TAppReverseIndexSuggestedShare = TAppReverseIndexSuggestedShare.read(input);
                            value_95.push(value_96);
                        }
                        input.readListEnd();
                        _args.suggestedShares = value_95;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_97: string = input.readString();
                        _args.displayString = value_97;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppReverseIndexSuggestedShareData(_args);
    }
}
export interface ITAppAddNearbyShareRequestArgs {
    requestingUserId?: string;
    requestingUserMinContact?: PContact.TAppContact;
    notificationId?: string;
}
export class TAppAddNearbyShareRequest {
    public requestingUserId?: string;
    public requestingUserMinContact?: PContact.TAppContact;
    public notificationId?: string;
    constructor(args?: ITAppAddNearbyShareRequestArgs) {
        if (args != null && args.requestingUserId != null) {
            this.requestingUserId = args.requestingUserId;
        }
        if (args != null && args.requestingUserMinContact != null) {
            this.requestingUserMinContact = args.requestingUserMinContact;
        }
        if (args != null && args.notificationId != null) {
            this.notificationId = args.notificationId;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppAddNearbyShareRequest");
        if (this.requestingUserId != null) {
            output.writeFieldBegin("requestingUserId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.requestingUserId);
            output.writeFieldEnd();
        }
        if (this.requestingUserMinContact != null) {
            output.writeFieldBegin("requestingUserMinContact", thrift.Thrift.Type.STRUCT, 2);
            this.requestingUserMinContact.write(output);
            output.writeFieldEnd();
        }
        if (this.notificationId != null) {
            output.writeFieldBegin("notificationId", thrift.Thrift.Type.STRING, 3);
            output.writeString(this.notificationId);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppAddNearbyShareRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_98: string = input.readString();
                        _args.requestingUserId = value_98;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_99: PContact.TAppContact = PContact.TAppContact.read(input);
                        _args.requestingUserMinContact = value_99;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_100: string = input.readString();
                        _args.notificationId = value_100;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppAddNearbyShareRequest(_args);
    }
}
export interface ITAppAddNearbyShareRequestDataArgs {
    shareRequests?: Array<TAppAddNearbyShareRequest>;
}
export class TAppAddNearbyShareRequestData {
    public shareRequests?: Array<TAppAddNearbyShareRequest>;
    constructor(args?: ITAppAddNearbyShareRequestDataArgs) {
        if (args != null && args.shareRequests != null) {
            this.shareRequests = args.shareRequests;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppAddNearbyShareRequestData");
        if (this.shareRequests != null) {
            output.writeFieldBegin("shareRequests", thrift.Thrift.Type.LIST, 1);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.shareRequests.length);
            this.shareRequests.forEach((value_101: TAppAddNearbyShareRequest): void => {
                value_101.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppAddNearbyShareRequestData {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_102: Array<TAppAddNearbyShareRequest> = new Array<TAppAddNearbyShareRequest>();
                        const metadata_13: thrift.TList = input.readListBegin();
                        const size_13: number = metadata_13.size;
                        for (let i_13: number = 0; i_13 < size_13; i_13++) {
                            const value_103: TAppAddNearbyShareRequest = TAppAddNearbyShareRequest.read(input);
                            value_102.push(value_103);
                        }
                        input.readListEnd();
                        _args.shareRequests = value_102;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppAddNearbyShareRequestData(_args);
    }
}
export interface ITFetchHomepageDataRequestArgs {
    currentLocation?: PLocation.TAppLocation;
    userIdsNearbyByBLE?: Array<string>;
    timezoneName: string;
    componentFlags?: Set<TAppHomePageModule>;
}
export class TFetchHomepageDataRequest {
    public currentLocation?: PLocation.TAppLocation;
    public userIdsNearbyByBLE?: Array<string>;
    public timezoneName: string;
    public componentFlags?: Set<TAppHomePageModule>;
    constructor(args: ITFetchHomepageDataRequestArgs) {
        if (args != null && args.currentLocation != null) {
            this.currentLocation = args.currentLocation;
        }
        if (args != null && args.userIdsNearbyByBLE != null) {
            this.userIdsNearbyByBLE = args.userIdsNearbyByBLE;
        }
        if (args != null && args.timezoneName != null) {
            this.timezoneName = args.timezoneName;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[timezoneName] is unset!");
        }
        if (args != null && args.componentFlags != null) {
            this.componentFlags = args.componentFlags;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TFetchHomepageDataRequest");
        if (this.currentLocation != null) {
            output.writeFieldBegin("currentLocation", thrift.Thrift.Type.STRUCT, 1);
            this.currentLocation.write(output);
            output.writeFieldEnd();
        }
        if (this.userIdsNearbyByBLE != null) {
            output.writeFieldBegin("userIdsNearbyByBLE", thrift.Thrift.Type.LIST, 2);
            output.writeListBegin(thrift.Thrift.Type.STRING, this.userIdsNearbyByBLE.length);
            this.userIdsNearbyByBLE.forEach((value_104: string): void => {
                output.writeString(value_104);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.timezoneName != null) {
            output.writeFieldBegin("timezoneName", thrift.Thrift.Type.STRING, 3);
            output.writeString(this.timezoneName);
            output.writeFieldEnd();
        }
        if (this.componentFlags != null) {
            output.writeFieldBegin("componentFlags", thrift.Thrift.Type.SET, 4);
            output.writeSetBegin(thrift.Thrift.Type.I32, this.componentFlags.size);
            this.componentFlags.forEach((value_105: TAppHomePageModule): void => {
                output.writeI32(value_105);
            });
            output.writeSetEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TFetchHomepageDataRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_106: PLocation.TAppLocation = PLocation.TAppLocation.read(input);
                        _args.currentLocation = value_106;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_107: Array<string> = new Array<string>();
                        const metadata_14: thrift.TList = input.readListBegin();
                        const size_14: number = metadata_14.size;
                        for (let i_14: number = 0; i_14 < size_14; i_14++) {
                            const value_108: string = input.readString();
                            value_107.push(value_108);
                        }
                        input.readListEnd();
                        _args.userIdsNearbyByBLE = value_107;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_109: string = input.readString();
                        _args.timezoneName = value_109;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.SET) {
                        const value_110: Set<TAppHomePageModule> = new Set<TAppHomePageModule>();
                        const metadata_15: thrift.TSet = input.readSetBegin();
                        const size_15: number = metadata_15.size;
                        for (let i_15: number = 0; i_15 < size_15; i_15++) {
                            const value_111: TAppHomePageModule = input.readI32();
                            value_110.add(value_111);
                        }
                        input.readSetEnd();
                        _args.componentFlags = value_110;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.timezoneName !== undefined) {
            return new TFetchHomepageDataRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TFetchHomepageDataRequest from input");
        }
    }
}
export interface ITAppGenericNotificationArgs {
    notificationId?: string;
}
export class TAppGenericNotification {
    public notificationId?: string;
    constructor(args?: ITAppGenericNotificationArgs) {
        if (args != null && args.notificationId != null) {
            this.notificationId = args.notificationId;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppGenericNotification");
        if (this.notificationId != null) {
            output.writeFieldBegin("notificationId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.notificationId);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppGenericNotification {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_112: string = input.readString();
                        _args.notificationId = value_112;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppGenericNotification(_args);
    }
}
export interface ITAppGenericNotificationDataArgs {
    genericNotifications?: Array<TAppGenericNotification>;
}
export class TAppGenericNotificationData {
    public genericNotifications?: Array<TAppGenericNotification>;
    constructor(args?: ITAppGenericNotificationDataArgs) {
        if (args != null && args.genericNotifications != null) {
            this.genericNotifications = args.genericNotifications;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppGenericNotificationData");
        if (this.genericNotifications != null) {
            output.writeFieldBegin("genericNotifications", thrift.Thrift.Type.LIST, 1);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.genericNotifications.length);
            this.genericNotifications.forEach((value_113: TAppGenericNotification): void => {
                value_113.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppGenericNotificationData {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_114: Array<TAppGenericNotification> = new Array<TAppGenericNotification>();
                        const metadata_16: thrift.TList = input.readListBegin();
                        const size_16: number = metadata_16.size;
                        for (let i_16: number = 0; i_16 < size_16; i_16++) {
                            const value_115: TAppGenericNotification = TAppGenericNotification.read(input);
                            value_114.push(value_115);
                        }
                        input.readListEnd();
                        _args.genericNotifications = value_114;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppGenericNotificationData(_args);
    }
}
export interface ITAppNameSuggestionDataArgs {
    nameSuggestionCount?: number;
    displayString?: string;
    nameSuggestions?: Array<PNameSuggestion.TAppNameSuggestion>;
}
export class TAppNameSuggestionData {
    public nameSuggestionCount?: number;
    public displayString?: string;
    public nameSuggestions?: Array<PNameSuggestion.TAppNameSuggestion>;
    constructor(args?: ITAppNameSuggestionDataArgs) {
        if (args != null && args.nameSuggestionCount != null) {
            this.nameSuggestionCount = args.nameSuggestionCount;
        }
        if (args != null && args.displayString != null) {
            this.displayString = args.displayString;
        }
        if (args != null && args.nameSuggestions != null) {
            this.nameSuggestions = args.nameSuggestions;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppNameSuggestionData");
        if (this.nameSuggestionCount != null) {
            output.writeFieldBegin("nameSuggestionCount", thrift.Thrift.Type.I32, 1);
            output.writeI32(this.nameSuggestionCount);
            output.writeFieldEnd();
        }
        if (this.displayString != null) {
            output.writeFieldBegin("displayString", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.displayString);
            output.writeFieldEnd();
        }
        if (this.nameSuggestions != null) {
            output.writeFieldBegin("nameSuggestions", thrift.Thrift.Type.LIST, 3);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.nameSuggestions.length);
            this.nameSuggestions.forEach((value_116: PNameSuggestion.TAppNameSuggestion): void => {
                value_116.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppNameSuggestionData {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_117: number = input.readI32();
                        _args.nameSuggestionCount = value_117;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_118: string = input.readString();
                        _args.displayString = value_118;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_119: Array<PNameSuggestion.TAppNameSuggestion> = new Array<PNameSuggestion.TAppNameSuggestion>();
                        const metadata_17: thrift.TList = input.readListBegin();
                        const size_17: number = metadata_17.size;
                        for (let i_17: number = 0; i_17 < size_17; i_17++) {
                            const value_120: PNameSuggestion.TAppNameSuggestion = PNameSuggestion.TAppNameSuggestion.read(input);
                            value_119.push(value_120);
                        }
                        input.readListEnd();
                        _args.nameSuggestions = value_119;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppNameSuggestionData(_args);
    }
}
export interface ITAppNameCompletionDataArgs {
    nameCompletionCount?: number;
    displayString?: string;
    nameCompletions?: Array<PNameSuggestion.TAppNameSuggestion>;
}
export class TAppNameCompletionData {
    public nameCompletionCount?: number;
    public displayString?: string;
    public nameCompletions?: Array<PNameSuggestion.TAppNameSuggestion>;
    constructor(args?: ITAppNameCompletionDataArgs) {
        if (args != null && args.nameCompletionCount != null) {
            this.nameCompletionCount = args.nameCompletionCount;
        }
        if (args != null && args.displayString != null) {
            this.displayString = args.displayString;
        }
        if (args != null && args.nameCompletions != null) {
            this.nameCompletions = args.nameCompletions;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppNameCompletionData");
        if (this.nameCompletionCount != null) {
            output.writeFieldBegin("nameCompletionCount", thrift.Thrift.Type.I32, 1);
            output.writeI32(this.nameCompletionCount);
            output.writeFieldEnd();
        }
        if (this.displayString != null) {
            output.writeFieldBegin("displayString", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.displayString);
            output.writeFieldEnd();
        }
        if (this.nameCompletions != null) {
            output.writeFieldBegin("nameCompletions", thrift.Thrift.Type.LIST, 3);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.nameCompletions.length);
            this.nameCompletions.forEach((value_121: PNameSuggestion.TAppNameSuggestion): void => {
                value_121.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppNameCompletionData {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_122: number = input.readI32();
                        _args.nameCompletionCount = value_122;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_123: string = input.readString();
                        _args.displayString = value_123;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_124: Array<PNameSuggestion.TAppNameSuggestion> = new Array<PNameSuggestion.TAppNameSuggestion>();
                        const metadata_18: thrift.TList = input.readListBegin();
                        const size_18: number = metadata_18.size;
                        for (let i_18: number = 0; i_18 < size_18; i_18++) {
                            const value_125: PNameSuggestion.TAppNameSuggestion = PNameSuggestion.TAppNameSuggestion.read(input);
                            value_124.push(value_125);
                        }
                        input.readListEnd();
                        _args.nameCompletions = value_124;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppNameCompletionData(_args);
    }
}
export interface ITAppExportSyncAccountArgs {
    accountId?: string;
    accountType?: Export.TAppExportAccountType;
    status?: Export.TAppExportAccountStatus;
}
export class TAppExportSyncAccount {
    public accountId?: string;
    public accountType?: Export.TAppExportAccountType;
    public status?: Export.TAppExportAccountStatus;
    constructor(args?: ITAppExportSyncAccountArgs) {
        if (args != null && args.accountId != null) {
            this.accountId = args.accountId;
        }
        if (args != null && args.accountType != null) {
            this.accountType = args.accountType;
        }
        if (args != null && args.status != null) {
            this.status = args.status;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppExportSyncAccount");
        if (this.accountId != null) {
            output.writeFieldBegin("accountId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.accountId);
            output.writeFieldEnd();
        }
        if (this.accountType != null) {
            output.writeFieldBegin("accountType", thrift.Thrift.Type.I32, 2);
            output.writeI32(this.accountType);
            output.writeFieldEnd();
        }
        if (this.status != null) {
            output.writeFieldBegin("status", thrift.Thrift.Type.I32, 3);
            output.writeI32(this.status);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppExportSyncAccount {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_126: string = input.readString();
                        _args.accountId = value_126;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_127: Export.TAppExportAccountType = input.readI32();
                        _args.accountType = value_127;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_128: Export.TAppExportAccountStatus = input.readI32();
                        _args.status = value_128;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppExportSyncAccount(_args);
    }
}
export interface ITAppExportSyncAccountStatusDataArgs {
    syncAccountStatuses?: Array<TAppExportSyncAccount>;
}
export class TAppExportSyncAccountStatusData {
    public syncAccountStatuses?: Array<TAppExportSyncAccount>;
    constructor(args?: ITAppExportSyncAccountStatusDataArgs) {
        if (args != null && args.syncAccountStatuses != null) {
            this.syncAccountStatuses = args.syncAccountStatuses;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppExportSyncAccountStatusData");
        if (this.syncAccountStatuses != null) {
            output.writeFieldBegin("syncAccountStatuses", thrift.Thrift.Type.LIST, 1);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.syncAccountStatuses.length);
            this.syncAccountStatuses.forEach((value_129: TAppExportSyncAccount): void => {
                value_129.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppExportSyncAccountStatusData {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_130: Array<TAppExportSyncAccount> = new Array<TAppExportSyncAccount>();
                        const metadata_19: thrift.TList = input.readListBegin();
                        const size_19: number = metadata_19.size;
                        for (let i_19: number = 0; i_19 < size_19; i_19++) {
                            const value_131: TAppExportSyncAccount = TAppExportSyncAccount.read(input);
                            value_130.push(value_131);
                        }
                        input.readListEnd();
                        _args.syncAccountStatuses = value_130;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppExportSyncAccountStatusData(_args);
    }
}
export interface ITAppExportSyncUserStatusDataArgs {
    syncUserStatuses?: Array<Export.TAppExportAccountStatus>;
}
export class TAppExportSyncUserStatusData {
    public syncUserStatuses?: Array<Export.TAppExportAccountStatus>;
    constructor(args?: ITAppExportSyncUserStatusDataArgs) {
        if (args != null && args.syncUserStatuses != null) {
            this.syncUserStatuses = args.syncUserStatuses;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppExportSyncUserStatusData");
        if (this.syncUserStatuses != null) {
            output.writeFieldBegin("syncUserStatuses", thrift.Thrift.Type.LIST, 1);
            output.writeListBegin(thrift.Thrift.Type.I32, this.syncUserStatuses.length);
            this.syncUserStatuses.forEach((value_132: Export.TAppExportAccountStatus): void => {
                output.writeI32(value_132);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppExportSyncUserStatusData {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_133: Array<Export.TAppExportAccountStatus> = new Array<Export.TAppExportAccountStatus>();
                        const metadata_20: thrift.TList = input.readListBegin();
                        const size_20: number = metadata_20.size;
                        for (let i_20: number = 0; i_20 < size_20; i_20++) {
                            const value_134: Export.TAppExportAccountStatus = input.readI32();
                            value_133.push(value_134);
                        }
                        input.readListEnd();
                        _args.syncUserStatuses = value_133;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppExportSyncUserStatusData(_args);
    }
}
export interface ITAppUnarchiveSuggestionDataArgs {
    unarchiveSuggestionCount?: number;
    displayString?: string;
    unarchiveSuggestions?: Array<PUnarchiveSuggestion.TAppUnarchiveSuggestion>;
}
export class TAppUnarchiveSuggestionData {
    public unarchiveSuggestionCount?: number;
    public displayString?: string;
    public unarchiveSuggestions?: Array<PUnarchiveSuggestion.TAppUnarchiveSuggestion>;
    constructor(args?: ITAppUnarchiveSuggestionDataArgs) {
        if (args != null && args.unarchiveSuggestionCount != null) {
            this.unarchiveSuggestionCount = args.unarchiveSuggestionCount;
        }
        if (args != null && args.displayString != null) {
            this.displayString = args.displayString;
        }
        if (args != null && args.unarchiveSuggestions != null) {
            this.unarchiveSuggestions = args.unarchiveSuggestions;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppUnarchiveSuggestionData");
        if (this.unarchiveSuggestionCount != null) {
            output.writeFieldBegin("unarchiveSuggestionCount", thrift.Thrift.Type.I32, 1);
            output.writeI32(this.unarchiveSuggestionCount);
            output.writeFieldEnd();
        }
        if (this.displayString != null) {
            output.writeFieldBegin("displayString", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.displayString);
            output.writeFieldEnd();
        }
        if (this.unarchiveSuggestions != null) {
            output.writeFieldBegin("unarchiveSuggestions", thrift.Thrift.Type.LIST, 3);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.unarchiveSuggestions.length);
            this.unarchiveSuggestions.forEach((value_135: PUnarchiveSuggestion.TAppUnarchiveSuggestion): void => {
                value_135.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppUnarchiveSuggestionData {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_136: number = input.readI32();
                        _args.unarchiveSuggestionCount = value_136;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_137: string = input.readString();
                        _args.displayString = value_137;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_138: Array<PUnarchiveSuggestion.TAppUnarchiveSuggestion> = new Array<PUnarchiveSuggestion.TAppUnarchiveSuggestion>();
                        const metadata_21: thrift.TList = input.readListBegin();
                        const size_21: number = metadata_21.size;
                        for (let i_21: number = 0; i_21 < size_21; i_21++) {
                            const value_139: PUnarchiveSuggestion.TAppUnarchiveSuggestion = PUnarchiveSuggestion.TAppUnarchiveSuggestion.read(input);
                            value_138.push(value_139);
                        }
                        input.readListEnd();
                        _args.unarchiveSuggestions = value_138;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppUnarchiveSuggestionData(_args);
    }
}
export interface ITAppBirthdayContactDataArgs {
    contactId: string;
    birthday: PContact.TAppDate;
}
export class TAppBirthdayContactData {
    public contactId: string;
    public birthday: PContact.TAppDate;
    constructor(args: ITAppBirthdayContactDataArgs) {
        if (args != null && args.contactId != null) {
            this.contactId = args.contactId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[contactId] is unset!");
        }
        if (args != null && args.birthday != null) {
            this.birthday = args.birthday;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[birthday] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppBirthdayContactData");
        if (this.contactId != null) {
            output.writeFieldBegin("contactId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.contactId);
            output.writeFieldEnd();
        }
        if (this.birthday != null) {
            output.writeFieldBegin("birthday", thrift.Thrift.Type.STRUCT, 2);
            this.birthday.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppBirthdayContactData {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_140: string = input.readString();
                        _args.contactId = value_140;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_141: PContact.TAppDate = PContact.TAppDate.read(input);
                        _args.birthday = value_141;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.contactId !== undefined && _args.birthday !== undefined) {
            return new TAppBirthdayContactData(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppBirthdayContactData from input");
        }
    }
}
export interface ITAppMergeSuggestionDataArgs {
    mergeSuggestionId: string;
    appContact1: PContact.TAppContact;
    appContact2: PContact.TAppContact;
    lastActedOnContact1?: number | Int64;
    lastActedOnContact2?: number | Int64;
}
export class TAppMergeSuggestionData {
    public mergeSuggestionId: string;
    public appContact1: PContact.TAppContact;
    public appContact2: PContact.TAppContact;
    public lastActedOnContact1?: Int64;
    public lastActedOnContact2?: Int64;
    constructor(args: ITAppMergeSuggestionDataArgs) {
        if (args != null && args.mergeSuggestionId != null) {
            this.mergeSuggestionId = args.mergeSuggestionId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[mergeSuggestionId] is unset!");
        }
        if (args != null && args.appContact1 != null) {
            this.appContact1 = args.appContact1;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[appContact1] is unset!");
        }
        if (args != null && args.appContact2 != null) {
            this.appContact2 = args.appContact2;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[appContact2] is unset!");
        }
        if (args != null && args.lastActedOnContact1 != null) {
            if (typeof args.lastActedOnContact1 === "number") {
                this.lastActedOnContact1 = new Int64(args.lastActedOnContact1);
            }
            else {
                this.lastActedOnContact1 = args.lastActedOnContact1;
            }
        }
        if (args != null && args.lastActedOnContact2 != null) {
            if (typeof args.lastActedOnContact2 === "number") {
                this.lastActedOnContact2 = new Int64(args.lastActedOnContact2);
            }
            else {
                this.lastActedOnContact2 = args.lastActedOnContact2;
            }
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppMergeSuggestionData");
        if (this.mergeSuggestionId != null) {
            output.writeFieldBegin("mergeSuggestionId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.mergeSuggestionId);
            output.writeFieldEnd();
        }
        if (this.appContact1 != null) {
            output.writeFieldBegin("appContact1", thrift.Thrift.Type.STRUCT, 3);
            this.appContact1.write(output);
            output.writeFieldEnd();
        }
        if (this.appContact2 != null) {
            output.writeFieldBegin("appContact2", thrift.Thrift.Type.STRUCT, 4);
            this.appContact2.write(output);
            output.writeFieldEnd();
        }
        if (this.lastActedOnContact1 != null) {
            output.writeFieldBegin("lastActedOnContact1", thrift.Thrift.Type.I64, 5);
            output.writeI64(this.lastActedOnContact1);
            output.writeFieldEnd();
        }
        if (this.lastActedOnContact2 != null) {
            output.writeFieldBegin("lastActedOnContact2", thrift.Thrift.Type.I64, 6);
            output.writeI64(this.lastActedOnContact2);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppMergeSuggestionData {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_142: string = input.readString();
                        _args.mergeSuggestionId = value_142;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_143: PContact.TAppContact = PContact.TAppContact.read(input);
                        _args.appContact1 = value_143;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_144: PContact.TAppContact = PContact.TAppContact.read(input);
                        _args.appContact2 = value_144;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_145: Int64 = input.readI64();
                        _args.lastActedOnContact1 = value_145;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 6:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_146: Int64 = input.readI64();
                        _args.lastActedOnContact2 = value_146;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.mergeSuggestionId !== undefined && _args.appContact1 !== undefined && _args.appContact2 !== undefined) {
            return new TAppMergeSuggestionData(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppMergeSuggestionData from input");
        }
    }
}
export interface ITAppShareSuggestionDataArgs {
    contact: PContact.TAppContact;
    shareType?: TSuggestedSharingInformationType;
}
export class TAppShareSuggestionData {
    public contact: PContact.TAppContact;
    public shareType?: TSuggestedSharingInformationType;
    constructor(args: ITAppShareSuggestionDataArgs) {
        if (args != null && args.contact != null) {
            this.contact = args.contact;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[contact] is unset!");
        }
        if (args != null && args.shareType != null) {
            this.shareType = args.shareType;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppShareSuggestionData");
        if (this.contact != null) {
            output.writeFieldBegin("contact", thrift.Thrift.Type.STRUCT, 1);
            this.contact.write(output);
            output.writeFieldEnd();
        }
        if (this.shareType != null) {
            output.writeFieldBegin("shareType", thrift.Thrift.Type.I32, 2);
            output.writeI32(this.shareType);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppShareSuggestionData {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_147: PContact.TAppContact = PContact.TAppContact.read(input);
                        _args.contact = value_147;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_148: TSuggestedSharingInformationType = input.readI32();
                        _args.shareType = value_148;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.contact !== undefined) {
            return new TAppShareSuggestionData(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppShareSuggestionData from input");
        }
    }
}
export interface ITAppShareSelfDataArgs {
    sharedContact: PContact.TAppContact;
    isShareBackVisible?: boolean;
}
export class TAppShareSelfData {
    public sharedContact: PContact.TAppContact;
    public isShareBackVisible?: boolean;
    constructor(args: ITAppShareSelfDataArgs) {
        if (args != null && args.sharedContact != null) {
            this.sharedContact = args.sharedContact;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[sharedContact] is unset!");
        }
        if (args != null && args.isShareBackVisible != null) {
            this.isShareBackVisible = args.isShareBackVisible;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppShareSelfData");
        if (this.sharedContact != null) {
            output.writeFieldBegin("sharedContact", thrift.Thrift.Type.STRUCT, 1);
            this.sharedContact.write(output);
            output.writeFieldEnd();
        }
        if (this.isShareBackVisible != null) {
            output.writeFieldBegin("isShareBackVisible", thrift.Thrift.Type.BOOL, 5);
            output.writeBool(this.isShareBackVisible);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppShareSelfData {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_149: PContact.TAppContact = PContact.TAppContact.read(input);
                        _args.sharedContact = value_149;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_150: boolean = input.readBool();
                        _args.isShareBackVisible = value_150;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.sharedContact !== undefined) {
            return new TAppShareSelfData(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppShareSelfData from input");
        }
    }
}
export interface ITAppShareOtherDataArgs {
    senderContact: PContact.TAppContact;
    sharedContact: PContact.TAppContact;
}
export class TAppShareOtherData {
    public senderContact: PContact.TAppContact;
    public sharedContact: PContact.TAppContact;
    constructor(args: ITAppShareOtherDataArgs) {
        if (args != null && args.senderContact != null) {
            this.senderContact = args.senderContact;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[senderContact] is unset!");
        }
        if (args != null && args.sharedContact != null) {
            this.sharedContact = args.sharedContact;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[sharedContact] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppShareOtherData");
        if (this.senderContact != null) {
            output.writeFieldBegin("senderContact", thrift.Thrift.Type.STRUCT, 1);
            this.senderContact.write(output);
            output.writeFieldEnd();
        }
        if (this.sharedContact != null) {
            output.writeFieldBegin("sharedContact", thrift.Thrift.Type.STRUCT, 2);
            this.sharedContact.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppShareOtherData {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_151: PContact.TAppContact = PContact.TAppContact.read(input);
                        _args.senderContact = value_151;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_152: PContact.TAppContact = PContact.TAppContact.read(input);
                        _args.sharedContact = value_152;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.senderContact !== undefined && _args.sharedContact !== undefined) {
            return new TAppShareOtherData(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppShareOtherData from input");
        }
    }
}
export interface ITAppGmailProcessingStatusDataArgs {
    accountId: string;
}
export class TAppGmailProcessingStatusData {
    public accountId: string;
    constructor(args: ITAppGmailProcessingStatusDataArgs) {
        if (args != null && args.accountId != null) {
            this.accountId = args.accountId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[accountId] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppGmailProcessingStatusData");
        if (this.accountId != null) {
            output.writeFieldBegin("accountId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.accountId);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppGmailProcessingStatusData {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_153: string = input.readString();
                        _args.accountId = value_153;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.accountId !== undefined) {
            return new TAppGmailProcessingStatusData(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppGmailProcessingStatusData from input");
        }
    }
}
export interface ITAppHomePageModuleDataArgs {
    moduleType?: TAppHomePageModule;
    data?: TAppHomePageModuleDataType;
    dataHashUUID?: string;
}
export class TAppHomePageModuleData {
    public moduleType?: TAppHomePageModule;
    public data?: TAppHomePageModuleDataType;
    public dataHashUUID?: string;
    constructor(args?: ITAppHomePageModuleDataArgs) {
        if (args != null && args.moduleType != null) {
            this.moduleType = args.moduleType;
        }
        if (args != null && args.data != null) {
            this.data = args.data;
        }
        if (args != null && args.dataHashUUID != null) {
            this.dataHashUUID = args.dataHashUUID;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppHomePageModuleData");
        if (this.moduleType != null) {
            output.writeFieldBegin("moduleType", thrift.Thrift.Type.I32, 1);
            output.writeI32(this.moduleType);
            output.writeFieldEnd();
        }
        if (this.data != null) {
            output.writeFieldBegin("data", thrift.Thrift.Type.STRUCT, 2);
            this.data.write(output);
            output.writeFieldEnd();
        }
        if (this.dataHashUUID != null) {
            output.writeFieldBegin("dataHashUUID", thrift.Thrift.Type.STRING, 3);
            output.writeString(this.dataHashUUID);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppHomePageModuleData {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_154: TAppHomePageModule = input.readI32();
                        _args.moduleType = value_154;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_155: TAppHomePageModuleDataType = TAppHomePageModuleDataType.read(input);
                        _args.data = value_155;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_156: string = input.readString();
                        _args.dataHashUUID = value_156;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppHomePageModuleData(_args);
    }
}
export interface ITFetchHomepageDataResponseArgs {
    rankedModules?: Map<TAppHomePageModule, number>;
    birthdayData?: TAppBirthdayData;
    mergeConfirmationData?: TAppMergeConfirmationData;
    shareRequestData?: TAppShareRequestData;
    introductionData?: TAppIntroductionData;
    engagementData?: TAppEngagementData;
    customData?: TAppCustomData;
    additionalSelfContactData?: TAppAdditionalSelfContactData;
    statsData?: TAppStatsData;
    webAuthData?: TAppWebAuthData;
    reverseIndexData?: TAppReverseIndexSuggestedShareData;
    addNearbyShareRequestData?: TAppAddNearbyShareRequestData;
    genericNotificationData?: TAppGenericNotificationData;
    nameSuggestionData?: TAppNameSuggestionData;
    sortedModules: Array<TAppHomePageModuleData>;
    welcomeData?: TAppWelcomeData;
    dashboardData?: TAppDashboardData;
    topContactsData?: TAppTopContactsData;
    nearbyData?: TAppNearbyData;
    lumiAssistantData?: TAppLumiAssistantData;
}
export class TFetchHomepageDataResponse {
    public rankedModules?: Map<TAppHomePageModule, number>;
    public birthdayData?: TAppBirthdayData;
    public mergeConfirmationData?: TAppMergeConfirmationData;
    public shareRequestData?: TAppShareRequestData;
    public introductionData?: TAppIntroductionData;
    public engagementData?: TAppEngagementData;
    public customData?: TAppCustomData;
    public additionalSelfContactData?: TAppAdditionalSelfContactData;
    public statsData?: TAppStatsData;
    public webAuthData?: TAppWebAuthData;
    public reverseIndexData?: TAppReverseIndexSuggestedShareData;
    public addNearbyShareRequestData?: TAppAddNearbyShareRequestData;
    public genericNotificationData?: TAppGenericNotificationData;
    public nameSuggestionData?: TAppNameSuggestionData;
    public sortedModules: Array<TAppHomePageModuleData>;
    public welcomeData?: TAppWelcomeData;
    public dashboardData?: TAppDashboardData;
    public topContactsData?: TAppTopContactsData;
    public nearbyData?: TAppNearbyData;
    public lumiAssistantData?: TAppLumiAssistantData;
    constructor(args: ITFetchHomepageDataResponseArgs) {
        if (args != null && args.rankedModules != null) {
            this.rankedModules = args.rankedModules;
        }
        if (args != null && args.birthdayData != null) {
            this.birthdayData = args.birthdayData;
        }
        if (args != null && args.mergeConfirmationData != null) {
            this.mergeConfirmationData = args.mergeConfirmationData;
        }
        if (args != null && args.shareRequestData != null) {
            this.shareRequestData = args.shareRequestData;
        }
        if (args != null && args.introductionData != null) {
            this.introductionData = args.introductionData;
        }
        if (args != null && args.engagementData != null) {
            this.engagementData = args.engagementData;
        }
        if (args != null && args.customData != null) {
            this.customData = args.customData;
        }
        if (args != null && args.additionalSelfContactData != null) {
            this.additionalSelfContactData = args.additionalSelfContactData;
        }
        if (args != null && args.statsData != null) {
            this.statsData = args.statsData;
        }
        if (args != null && args.webAuthData != null) {
            this.webAuthData = args.webAuthData;
        }
        if (args != null && args.reverseIndexData != null) {
            this.reverseIndexData = args.reverseIndexData;
        }
        if (args != null && args.addNearbyShareRequestData != null) {
            this.addNearbyShareRequestData = args.addNearbyShareRequestData;
        }
        if (args != null && args.genericNotificationData != null) {
            this.genericNotificationData = args.genericNotificationData;
        }
        if (args != null && args.nameSuggestionData != null) {
            this.nameSuggestionData = args.nameSuggestionData;
        }
        if (args != null && args.sortedModules != null) {
            this.sortedModules = args.sortedModules;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[sortedModules] is unset!");
        }
        if (args != null && args.welcomeData != null) {
            this.welcomeData = args.welcomeData;
        }
        if (args != null && args.dashboardData != null) {
            this.dashboardData = args.dashboardData;
        }
        if (args != null && args.topContactsData != null) {
            this.topContactsData = args.topContactsData;
        }
        if (args != null && args.nearbyData != null) {
            this.nearbyData = args.nearbyData;
        }
        if (args != null && args.lumiAssistantData != null) {
            this.lumiAssistantData = args.lumiAssistantData;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TFetchHomepageDataResponse");
        if (this.rankedModules != null) {
            output.writeFieldBegin("rankedModules", thrift.Thrift.Type.MAP, 1);
            output.writeMapBegin(thrift.Thrift.Type.I32, thrift.Thrift.Type.I32, this.rankedModules.size);
            this.rankedModules.forEach((value_157: number, key_3: TAppHomePageModule): void => {
                output.writeI32(key_3);
                output.writeI32(value_157);
            });
            output.writeMapEnd();
            output.writeFieldEnd();
        }
        if (this.birthdayData != null) {
            output.writeFieldBegin("birthdayData", thrift.Thrift.Type.STRUCT, 6);
            this.birthdayData.write(output);
            output.writeFieldEnd();
        }
        if (this.mergeConfirmationData != null) {
            output.writeFieldBegin("mergeConfirmationData", thrift.Thrift.Type.STRUCT, 7);
            this.mergeConfirmationData.write(output);
            output.writeFieldEnd();
        }
        if (this.shareRequestData != null) {
            output.writeFieldBegin("shareRequestData", thrift.Thrift.Type.STRUCT, 8);
            this.shareRequestData.write(output);
            output.writeFieldEnd();
        }
        if (this.introductionData != null) {
            output.writeFieldBegin("introductionData", thrift.Thrift.Type.STRUCT, 9);
            this.introductionData.write(output);
            output.writeFieldEnd();
        }
        if (this.engagementData != null) {
            output.writeFieldBegin("engagementData", thrift.Thrift.Type.STRUCT, 10);
            this.engagementData.write(output);
            output.writeFieldEnd();
        }
        if (this.customData != null) {
            output.writeFieldBegin("customData", thrift.Thrift.Type.STRUCT, 12);
            this.customData.write(output);
            output.writeFieldEnd();
        }
        if (this.additionalSelfContactData != null) {
            output.writeFieldBegin("additionalSelfContactData", thrift.Thrift.Type.STRUCT, 13);
            this.additionalSelfContactData.write(output);
            output.writeFieldEnd();
        }
        if (this.statsData != null) {
            output.writeFieldBegin("statsData", thrift.Thrift.Type.STRUCT, 14);
            this.statsData.write(output);
            output.writeFieldEnd();
        }
        if (this.webAuthData != null) {
            output.writeFieldBegin("webAuthData", thrift.Thrift.Type.STRUCT, 15);
            this.webAuthData.write(output);
            output.writeFieldEnd();
        }
        if (this.reverseIndexData != null) {
            output.writeFieldBegin("reverseIndexData", thrift.Thrift.Type.STRUCT, 16);
            this.reverseIndexData.write(output);
            output.writeFieldEnd();
        }
        if (this.addNearbyShareRequestData != null) {
            output.writeFieldBegin("addNearbyShareRequestData", thrift.Thrift.Type.STRUCT, 17);
            this.addNearbyShareRequestData.write(output);
            output.writeFieldEnd();
        }
        if (this.genericNotificationData != null) {
            output.writeFieldBegin("genericNotificationData", thrift.Thrift.Type.STRUCT, 18);
            this.genericNotificationData.write(output);
            output.writeFieldEnd();
        }
        if (this.nameSuggestionData != null) {
            output.writeFieldBegin("nameSuggestionData", thrift.Thrift.Type.STRUCT, 19);
            this.nameSuggestionData.write(output);
            output.writeFieldEnd();
        }
        if (this.sortedModules != null) {
            output.writeFieldBegin("sortedModules", thrift.Thrift.Type.LIST, 20);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.sortedModules.length);
            this.sortedModules.forEach((value_158: TAppHomePageModuleData): void => {
                value_158.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.welcomeData != null) {
            output.writeFieldBegin("welcomeData", thrift.Thrift.Type.STRUCT, 2);
            this.welcomeData.write(output);
            output.writeFieldEnd();
        }
        if (this.dashboardData != null) {
            output.writeFieldBegin("dashboardData", thrift.Thrift.Type.STRUCT, 3);
            this.dashboardData.write(output);
            output.writeFieldEnd();
        }
        if (this.topContactsData != null) {
            output.writeFieldBegin("topContactsData", thrift.Thrift.Type.STRUCT, 4);
            this.topContactsData.write(output);
            output.writeFieldEnd();
        }
        if (this.nearbyData != null) {
            output.writeFieldBegin("nearbyData", thrift.Thrift.Type.STRUCT, 5);
            this.nearbyData.write(output);
            output.writeFieldEnd();
        }
        if (this.lumiAssistantData != null) {
            output.writeFieldBegin("lumiAssistantData", thrift.Thrift.Type.STRUCT, 11);
            this.lumiAssistantData.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TFetchHomepageDataResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.MAP) {
                        const value_159: Map<TAppHomePageModule, number> = new Map<TAppHomePageModule, number>();
                        const metadata_22: thrift.TMap = input.readMapBegin();
                        const size_22: number = metadata_22.size;
                        for (let i_22: number = 0; i_22 < size_22; i_22++) {
                            const key_4: TAppHomePageModule = input.readI32();
                            const value_160: number = input.readI32();
                            value_159.set(key_4, value_160);
                        }
                        input.readMapEnd();
                        _args.rankedModules = value_159;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 6:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_161: TAppBirthdayData = TAppBirthdayData.read(input);
                        _args.birthdayData = value_161;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 7:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_162: TAppMergeConfirmationData = TAppMergeConfirmationData.read(input);
                        _args.mergeConfirmationData = value_162;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 8:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_163: TAppShareRequestData = TAppShareRequestData.read(input);
                        _args.shareRequestData = value_163;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 9:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_164: TAppIntroductionData = TAppIntroductionData.read(input);
                        _args.introductionData = value_164;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 10:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_165: TAppEngagementData = TAppEngagementData.read(input);
                        _args.engagementData = value_165;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 12:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_166: TAppCustomData = TAppCustomData.read(input);
                        _args.customData = value_166;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 13:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_167: TAppAdditionalSelfContactData = TAppAdditionalSelfContactData.read(input);
                        _args.additionalSelfContactData = value_167;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 14:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_168: TAppStatsData = TAppStatsData.read(input);
                        _args.statsData = value_168;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 15:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_169: TAppWebAuthData = TAppWebAuthData.read(input);
                        _args.webAuthData = value_169;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 16:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_170: TAppReverseIndexSuggestedShareData = TAppReverseIndexSuggestedShareData.read(input);
                        _args.reverseIndexData = value_170;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 17:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_171: TAppAddNearbyShareRequestData = TAppAddNearbyShareRequestData.read(input);
                        _args.addNearbyShareRequestData = value_171;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 18:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_172: TAppGenericNotificationData = TAppGenericNotificationData.read(input);
                        _args.genericNotificationData = value_172;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 19:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_173: TAppNameSuggestionData = TAppNameSuggestionData.read(input);
                        _args.nameSuggestionData = value_173;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 20:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_174: Array<TAppHomePageModuleData> = new Array<TAppHomePageModuleData>();
                        const metadata_23: thrift.TList = input.readListBegin();
                        const size_23: number = metadata_23.size;
                        for (let i_23: number = 0; i_23 < size_23; i_23++) {
                            const value_175: TAppHomePageModuleData = TAppHomePageModuleData.read(input);
                            value_174.push(value_175);
                        }
                        input.readListEnd();
                        _args.sortedModules = value_174;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_176: TAppWelcomeData = TAppWelcomeData.read(input);
                        _args.welcomeData = value_176;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_177: TAppDashboardData = TAppDashboardData.read(input);
                        _args.dashboardData = value_177;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_178: TAppTopContactsData = TAppTopContactsData.read(input);
                        _args.topContactsData = value_178;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_179: TAppNearbyData = TAppNearbyData.read(input);
                        _args.nearbyData = value_179;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 11:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_180: TAppLumiAssistantData = TAppLumiAssistantData.read(input);
                        _args.lumiAssistantData = value_180;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.sortedModules !== undefined) {
            return new TFetchHomepageDataResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TFetchHomepageDataResponse from input");
        }
    }
}
export interface ITImportSourceStatsArgs {
    contactCount: number;
    sourceDisplayString: string;
}
export class TImportSourceStats {
    public contactCount: number;
    public sourceDisplayString: string;
    constructor(args: ITImportSourceStatsArgs) {
        if (args != null && args.contactCount != null) {
            this.contactCount = args.contactCount;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[contactCount] is unset!");
        }
        if (args != null && args.sourceDisplayString != null) {
            this.sourceDisplayString = args.sourceDisplayString;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[sourceDisplayString] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TImportSourceStats");
        if (this.contactCount != null) {
            output.writeFieldBegin("contactCount", thrift.Thrift.Type.I32, 1);
            output.writeI32(this.contactCount);
            output.writeFieldEnd();
        }
        if (this.sourceDisplayString != null) {
            output.writeFieldBegin("sourceDisplayString", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.sourceDisplayString);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TImportSourceStats {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_181: number = input.readI32();
                        _args.contactCount = value_181;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_182: string = input.readString();
                        _args.sourceDisplayString = value_182;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.contactCount !== undefined && _args.sourceDisplayString !== undefined) {
            return new TImportSourceStats(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TImportSourceStats from input");
        }
    }
}
export interface ITEnhancedFieldsStatsArgs {
    enhancedPhoneCount: number;
    enhancedEmailCount: number;
    enhancedAddressCount: number;
    enhancedSocialProfileCount: number;
    addedProfessionalInfoCount: number;
}
export class TEnhancedFieldsStats {
    public enhancedPhoneCount: number;
    public enhancedEmailCount: number;
    public enhancedAddressCount: number;
    public enhancedSocialProfileCount: number;
    public addedProfessionalInfoCount: number;
    constructor(args: ITEnhancedFieldsStatsArgs) {
        if (args != null && args.enhancedPhoneCount != null) {
            this.enhancedPhoneCount = args.enhancedPhoneCount;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[enhancedPhoneCount] is unset!");
        }
        if (args != null && args.enhancedEmailCount != null) {
            this.enhancedEmailCount = args.enhancedEmailCount;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[enhancedEmailCount] is unset!");
        }
        if (args != null && args.enhancedAddressCount != null) {
            this.enhancedAddressCount = args.enhancedAddressCount;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[enhancedAddressCount] is unset!");
        }
        if (args != null && args.enhancedSocialProfileCount != null) {
            this.enhancedSocialProfileCount = args.enhancedSocialProfileCount;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[enhancedSocialProfileCount] is unset!");
        }
        if (args != null && args.addedProfessionalInfoCount != null) {
            this.addedProfessionalInfoCount = args.addedProfessionalInfoCount;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[addedProfessionalInfoCount] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TEnhancedFieldsStats");
        if (this.enhancedPhoneCount != null) {
            output.writeFieldBegin("enhancedPhoneCount", thrift.Thrift.Type.I32, 1);
            output.writeI32(this.enhancedPhoneCount);
            output.writeFieldEnd();
        }
        if (this.enhancedEmailCount != null) {
            output.writeFieldBegin("enhancedEmailCount", thrift.Thrift.Type.I32, 2);
            output.writeI32(this.enhancedEmailCount);
            output.writeFieldEnd();
        }
        if (this.enhancedAddressCount != null) {
            output.writeFieldBegin("enhancedAddressCount", thrift.Thrift.Type.I32, 3);
            output.writeI32(this.enhancedAddressCount);
            output.writeFieldEnd();
        }
        if (this.enhancedSocialProfileCount != null) {
            output.writeFieldBegin("enhancedSocialProfileCount", thrift.Thrift.Type.I32, 4);
            output.writeI32(this.enhancedSocialProfileCount);
            output.writeFieldEnd();
        }
        if (this.addedProfessionalInfoCount != null) {
            output.writeFieldBegin("addedProfessionalInfoCount", thrift.Thrift.Type.I32, 5);
            output.writeI32(this.addedProfessionalInfoCount);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TEnhancedFieldsStats {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_183: number = input.readI32();
                        _args.enhancedPhoneCount = value_183;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_184: number = input.readI32();
                        _args.enhancedEmailCount = value_184;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_185: number = input.readI32();
                        _args.enhancedAddressCount = value_185;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_186: number = input.readI32();
                        _args.enhancedSocialProfileCount = value_186;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_187: number = input.readI32();
                        _args.addedProfessionalInfoCount = value_187;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.enhancedPhoneCount !== undefined && _args.enhancedEmailCount !== undefined && _args.enhancedAddressCount !== undefined && _args.enhancedSocialProfileCount !== undefined && _args.addedProfessionalInfoCount !== undefined) {
            return new TEnhancedFieldsStats(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TEnhancedFieldsStats from input");
        }
    }
}
export interface ITContactListStatsArgs {
    contactListCount: number;
    archivedCount: number;
}
export class TContactListStats {
    public contactListCount: number;
    public archivedCount: number;
    constructor(args: ITContactListStatsArgs) {
        if (args != null && args.contactListCount != null) {
            this.contactListCount = args.contactListCount;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[contactListCount] is unset!");
        }
        if (args != null && args.archivedCount != null) {
            this.archivedCount = args.archivedCount;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[archivedCount] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TContactListStats");
        if (this.contactListCount != null) {
            output.writeFieldBegin("contactListCount", thrift.Thrift.Type.I32, 1);
            output.writeI32(this.contactListCount);
            output.writeFieldEnd();
        }
        if (this.archivedCount != null) {
            output.writeFieldBegin("archivedCount", thrift.Thrift.Type.I32, 2);
            output.writeI32(this.archivedCount);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TContactListStats {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_188: number = input.readI32();
                        _args.contactListCount = value_188;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_189: number = input.readI32();
                        _args.archivedCount = value_189;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.contactListCount !== undefined && _args.archivedCount !== undefined) {
            return new TContactListStats(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TContactListStats from input");
        }
    }
}
export interface ITGetOnboardingStatisticsRequestArgs {
    version: number;
}
export class TGetOnboardingStatisticsRequest {
    public version: number;
    constructor(args: ITGetOnboardingStatisticsRequestArgs) {
        if (args != null && args.version != null) {
            this.version = args.version;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[version] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TGetOnboardingStatisticsRequest");
        if (this.version != null) {
            output.writeFieldBegin("version", thrift.Thrift.Type.I16, 1);
            output.writeI16(this.version);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TGetOnboardingStatisticsRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.I16) {
                        const value_190: number = input.readI16();
                        _args.version = value_190;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.version !== undefined) {
            return new TGetOnboardingStatisticsRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TGetOnboardingStatisticsRequest from input");
        }
    }
}
export interface ITGetOnboardingStatisticsResponseArgs {
    totalImportedContactCount: number;
    sources?: Array<TImportSourceStats>;
    totalMergedContactCount?: number;
    contactListStats?: TContactListStats;
    enhancedFieldStats?: TEnhancedFieldsStats;
}
export class TGetOnboardingStatisticsResponse {
    public totalImportedContactCount: number;
    public sources?: Array<TImportSourceStats>;
    public totalMergedContactCount?: number;
    public contactListStats?: TContactListStats;
    public enhancedFieldStats?: TEnhancedFieldsStats;
    constructor(args: ITGetOnboardingStatisticsResponseArgs) {
        if (args != null && args.totalImportedContactCount != null) {
            this.totalImportedContactCount = args.totalImportedContactCount;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[totalImportedContactCount] is unset!");
        }
        if (args != null && args.sources != null) {
            this.sources = args.sources;
        }
        if (args != null && args.totalMergedContactCount != null) {
            this.totalMergedContactCount = args.totalMergedContactCount;
        }
        if (args != null && args.contactListStats != null) {
            this.contactListStats = args.contactListStats;
        }
        if (args != null && args.enhancedFieldStats != null) {
            this.enhancedFieldStats = args.enhancedFieldStats;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TGetOnboardingStatisticsResponse");
        if (this.totalImportedContactCount != null) {
            output.writeFieldBegin("totalImportedContactCount", thrift.Thrift.Type.I32, 1);
            output.writeI32(this.totalImportedContactCount);
            output.writeFieldEnd();
        }
        if (this.sources != null) {
            output.writeFieldBegin("sources", thrift.Thrift.Type.LIST, 2);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.sources.length);
            this.sources.forEach((value_191: TImportSourceStats): void => {
                value_191.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.totalMergedContactCount != null) {
            output.writeFieldBegin("totalMergedContactCount", thrift.Thrift.Type.I32, 3);
            output.writeI32(this.totalMergedContactCount);
            output.writeFieldEnd();
        }
        if (this.contactListStats != null) {
            output.writeFieldBegin("contactListStats", thrift.Thrift.Type.STRUCT, 4);
            this.contactListStats.write(output);
            output.writeFieldEnd();
        }
        if (this.enhancedFieldStats != null) {
            output.writeFieldBegin("enhancedFieldStats", thrift.Thrift.Type.STRUCT, 5);
            this.enhancedFieldStats.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TGetOnboardingStatisticsResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_192: number = input.readI32();
                        _args.totalImportedContactCount = value_192;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_193: Array<TImportSourceStats> = new Array<TImportSourceStats>();
                        const metadata_24: thrift.TList = input.readListBegin();
                        const size_24: number = metadata_24.size;
                        for (let i_24: number = 0; i_24 < size_24; i_24++) {
                            const value_194: TImportSourceStats = TImportSourceStats.read(input);
                            value_193.push(value_194);
                        }
                        input.readListEnd();
                        _args.sources = value_193;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_195: number = input.readI32();
                        _args.totalMergedContactCount = value_195;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_196: TContactListStats = TContactListStats.read(input);
                        _args.contactListStats = value_196;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_197: TEnhancedFieldsStats = TEnhancedFieldsStats.read(input);
                        _args.enhancedFieldStats = value_197;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.totalImportedContactCount !== undefined) {
            return new TGetOnboardingStatisticsResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TGetOnboardingStatisticsResponse from input");
        }
    }
}
export interface ITAppHomePageModuleDataTypeArgs {
    enhancementMetricsData?: TAppEnhancementMetrics;
    welcomeData?: TAppWelcomeData;
    dashboardData?: TAppDashboardData;
    topContactData?: TAppTopContact;
    topContactsData?: TAppTopContactsData;
    nearbyData?: TAppNearbyData;
    birthdayContactData?: TAppBirthdayContact;
    birthdayData?: TAppBirthdayData;
    mergeSuggestion?: TAppMergeSuggestion;
    mergeConfirmationData?: TAppMergeConfirmationData;
    mergeSuggestionData?: TAppMergeSuggestionData;
    shareRequestContactData?: TAppShareRequestContact;
    shareRequestData?: TAppShareRequestData;
    introductionContact?: TAppIntroductionContact;
    introductionData?: TAppIntroductionData;
    engagementData?: TAppEngagementData;
    lumiAssistantData?: TAppLumiAssistantData;
    customData?: TAppCustomData;
    isThisYouData?: TAppIsThisYouData;
    additionalSelfContactData?: TAppAdditionalSelfContactData;
    statsData?: TAppStatsData;
    webAuthData?: TAppWebAuthData;
    reverseIndexSuggestedShareData?: TAppReverseIndexSuggestedShareData;
    addNearbyShareRequestData?: TAppAddNearbyShareRequestData;
    fetchHomepageDataRequest?: TFetchHomepageDataRequest;
    genericNotification?: TAppGenericNotification;
    genericNotificationData?: TAppGenericNotificationData;
    nameSuggestionData?: TAppNameSuggestionData;
    unarchiveSuggestionData?: TAppUnarchiveSuggestionData;
    shareSuggestionData?: TAppShareSuggestionData;
    shareSelfData?: TAppShareSelfData;
    shareOtherData?: TAppShareOtherData;
    singleIntroDuctionData?: TAppSingleIntroductionData;
    gmailProcessingStatusData?: TAppGmailProcessingStatusData;
    nameCompletionData?: TAppNameCompletionData;
    syncUserStatusData?: TAppExportSyncUserStatusData;
    syncAccountStatusData?: TAppExportSyncAccountStatusData;
}
export class TAppHomePageModuleDataType {
    public enhancementMetricsData?: TAppEnhancementMetrics;
    public welcomeData?: TAppWelcomeData;
    public dashboardData?: TAppDashboardData;
    public topContactData?: TAppTopContact;
    public topContactsData?: TAppTopContactsData;
    public nearbyData?: TAppNearbyData;
    public birthdayContactData?: TAppBirthdayContact;
    public birthdayData?: TAppBirthdayData;
    public mergeSuggestion?: TAppMergeSuggestion;
    public mergeConfirmationData?: TAppMergeConfirmationData;
    public mergeSuggestionData?: TAppMergeSuggestionData;
    public shareRequestContactData?: TAppShareRequestContact;
    public shareRequestData?: TAppShareRequestData;
    public introductionContact?: TAppIntroductionContact;
    public introductionData?: TAppIntroductionData;
    public engagementData?: TAppEngagementData;
    public lumiAssistantData?: TAppLumiAssistantData;
    public customData?: TAppCustomData;
    public isThisYouData?: TAppIsThisYouData;
    public additionalSelfContactData?: TAppAdditionalSelfContactData;
    public statsData?: TAppStatsData;
    public webAuthData?: TAppWebAuthData;
    public reverseIndexSuggestedShareData?: TAppReverseIndexSuggestedShareData;
    public addNearbyShareRequestData?: TAppAddNearbyShareRequestData;
    public fetchHomepageDataRequest?: TFetchHomepageDataRequest;
    public genericNotification?: TAppGenericNotification;
    public genericNotificationData?: TAppGenericNotificationData;
    public nameSuggestionData?: TAppNameSuggestionData;
    public unarchiveSuggestionData?: TAppUnarchiveSuggestionData;
    public shareSuggestionData?: TAppShareSuggestionData;
    public shareSelfData?: TAppShareSelfData;
    public shareOtherData?: TAppShareOtherData;
    public singleIntroDuctionData?: TAppSingleIntroductionData;
    public gmailProcessingStatusData?: TAppGmailProcessingStatusData;
    public nameCompletionData?: TAppNameCompletionData;
    public syncUserStatusData?: TAppExportSyncUserStatusData;
    public syncAccountStatusData?: TAppExportSyncAccountStatusData;
    constructor(args?: ITAppHomePageModuleDataTypeArgs) {
        let _fieldsSet: number = 0;
        if (args != null) {
            if (args.enhancementMetricsData != null) {
                _fieldsSet++;
                this.enhancementMetricsData = args.enhancementMetricsData;
            }
            if (args.welcomeData != null) {
                _fieldsSet++;
                this.welcomeData = args.welcomeData;
            }
            if (args.dashboardData != null) {
                _fieldsSet++;
                this.dashboardData = args.dashboardData;
            }
            if (args.topContactData != null) {
                _fieldsSet++;
                this.topContactData = args.topContactData;
            }
            if (args.topContactsData != null) {
                _fieldsSet++;
                this.topContactsData = args.topContactsData;
            }
            if (args.nearbyData != null) {
                _fieldsSet++;
                this.nearbyData = args.nearbyData;
            }
            if (args.birthdayContactData != null) {
                _fieldsSet++;
                this.birthdayContactData = args.birthdayContactData;
            }
            if (args.birthdayData != null) {
                _fieldsSet++;
                this.birthdayData = args.birthdayData;
            }
            if (args.mergeSuggestion != null) {
                _fieldsSet++;
                this.mergeSuggestion = args.mergeSuggestion;
            }
            if (args.mergeConfirmationData != null) {
                _fieldsSet++;
                this.mergeConfirmationData = args.mergeConfirmationData;
            }
            if (args.mergeSuggestionData != null) {
                _fieldsSet++;
                this.mergeSuggestionData = args.mergeSuggestionData;
            }
            if (args.shareRequestContactData != null) {
                _fieldsSet++;
                this.shareRequestContactData = args.shareRequestContactData;
            }
            if (args.shareRequestData != null) {
                _fieldsSet++;
                this.shareRequestData = args.shareRequestData;
            }
            if (args.introductionContact != null) {
                _fieldsSet++;
                this.introductionContact = args.introductionContact;
            }
            if (args.introductionData != null) {
                _fieldsSet++;
                this.introductionData = args.introductionData;
            }
            if (args.engagementData != null) {
                _fieldsSet++;
                this.engagementData = args.engagementData;
            }
            if (args.lumiAssistantData != null) {
                _fieldsSet++;
                this.lumiAssistantData = args.lumiAssistantData;
            }
            if (args.customData != null) {
                _fieldsSet++;
                this.customData = args.customData;
            }
            if (args.isThisYouData != null) {
                _fieldsSet++;
                this.isThisYouData = args.isThisYouData;
            }
            if (args.additionalSelfContactData != null) {
                _fieldsSet++;
                this.additionalSelfContactData = args.additionalSelfContactData;
            }
            if (args.statsData != null) {
                _fieldsSet++;
                this.statsData = args.statsData;
            }
            if (args.webAuthData != null) {
                _fieldsSet++;
                this.webAuthData = args.webAuthData;
            }
            if (args.reverseIndexSuggestedShareData != null) {
                _fieldsSet++;
                this.reverseIndexSuggestedShareData = args.reverseIndexSuggestedShareData;
            }
            if (args.addNearbyShareRequestData != null) {
                _fieldsSet++;
                this.addNearbyShareRequestData = args.addNearbyShareRequestData;
            }
            if (args.fetchHomepageDataRequest != null) {
                _fieldsSet++;
                this.fetchHomepageDataRequest = args.fetchHomepageDataRequest;
            }
            if (args.genericNotification != null) {
                _fieldsSet++;
                this.genericNotification = args.genericNotification;
            }
            if (args.genericNotificationData != null) {
                _fieldsSet++;
                this.genericNotificationData = args.genericNotificationData;
            }
            if (args.nameSuggestionData != null) {
                _fieldsSet++;
                this.nameSuggestionData = args.nameSuggestionData;
            }
            if (args.unarchiveSuggestionData != null) {
                _fieldsSet++;
                this.unarchiveSuggestionData = args.unarchiveSuggestionData;
            }
            if (args.shareSuggestionData != null) {
                _fieldsSet++;
                this.shareSuggestionData = args.shareSuggestionData;
            }
            if (args.shareSelfData != null) {
                _fieldsSet++;
                this.shareSelfData = args.shareSelfData;
            }
            if (args.shareOtherData != null) {
                _fieldsSet++;
                this.shareOtherData = args.shareOtherData;
            }
            if (args.singleIntroDuctionData != null) {
                _fieldsSet++;
                this.singleIntroDuctionData = args.singleIntroDuctionData;
            }
            if (args.gmailProcessingStatusData != null) {
                _fieldsSet++;
                this.gmailProcessingStatusData = args.gmailProcessingStatusData;
            }
            if (args.nameCompletionData != null) {
                _fieldsSet++;
                this.nameCompletionData = args.nameCompletionData;
            }
            if (args.syncUserStatusData != null) {
                _fieldsSet++;
                this.syncUserStatusData = args.syncUserStatusData;
            }
            if (args.syncAccountStatusData != null) {
                _fieldsSet++;
                this.syncAccountStatusData = args.syncAccountStatusData;
            }
            if (_fieldsSet > 1) {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.INVALID_DATA, "Cannot read a TUnion with more than one set value!");
            }
            else if (_fieldsSet < 1) {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.INVALID_DATA, "Cannot read a TUnion with no set value!");
            }
        }
    }
    public static fromEnhancementMetricsData(enhancementMetricsData: TAppEnhancementMetrics): TAppHomePageModuleDataType {
        return new TAppHomePageModuleDataType({ enhancementMetricsData });
    }
    public static fromWelcomeData(welcomeData: TAppWelcomeData): TAppHomePageModuleDataType {
        return new TAppHomePageModuleDataType({ welcomeData });
    }
    public static fromDashboardData(dashboardData: TAppDashboardData): TAppHomePageModuleDataType {
        return new TAppHomePageModuleDataType({ dashboardData });
    }
    public static fromTopContactData(topContactData: TAppTopContact): TAppHomePageModuleDataType {
        return new TAppHomePageModuleDataType({ topContactData });
    }
    public static fromTopContactsData(topContactsData: TAppTopContactsData): TAppHomePageModuleDataType {
        return new TAppHomePageModuleDataType({ topContactsData });
    }
    public static fromNearbyData(nearbyData: TAppNearbyData): TAppHomePageModuleDataType {
        return new TAppHomePageModuleDataType({ nearbyData });
    }
    public static fromBirthdayContactData(birthdayContactData: TAppBirthdayContact): TAppHomePageModuleDataType {
        return new TAppHomePageModuleDataType({ birthdayContactData });
    }
    public static fromBirthdayData(birthdayData: TAppBirthdayData): TAppHomePageModuleDataType {
        return new TAppHomePageModuleDataType({ birthdayData });
    }
    public static fromMergeSuggestion(mergeSuggestion: TAppMergeSuggestion): TAppHomePageModuleDataType {
        return new TAppHomePageModuleDataType({ mergeSuggestion });
    }
    public static fromMergeConfirmationData(mergeConfirmationData: TAppMergeConfirmationData): TAppHomePageModuleDataType {
        return new TAppHomePageModuleDataType({ mergeConfirmationData });
    }
    public static fromMergeSuggestionData(mergeSuggestionData: TAppMergeSuggestionData): TAppHomePageModuleDataType {
        return new TAppHomePageModuleDataType({ mergeSuggestionData });
    }
    public static fromShareRequestContactData(shareRequestContactData: TAppShareRequestContact): TAppHomePageModuleDataType {
        return new TAppHomePageModuleDataType({ shareRequestContactData });
    }
    public static fromShareRequestData(shareRequestData: TAppShareRequestData): TAppHomePageModuleDataType {
        return new TAppHomePageModuleDataType({ shareRequestData });
    }
    public static fromIntroductionContact(introductionContact: TAppIntroductionContact): TAppHomePageModuleDataType {
        return new TAppHomePageModuleDataType({ introductionContact });
    }
    public static fromIntroductionData(introductionData: TAppIntroductionData): TAppHomePageModuleDataType {
        return new TAppHomePageModuleDataType({ introductionData });
    }
    public static fromEngagementData(engagementData: TAppEngagementData): TAppHomePageModuleDataType {
        return new TAppHomePageModuleDataType({ engagementData });
    }
    public static fromLumiAssistantData(lumiAssistantData: TAppLumiAssistantData): TAppHomePageModuleDataType {
        return new TAppHomePageModuleDataType({ lumiAssistantData });
    }
    public static fromCustomData(customData: TAppCustomData): TAppHomePageModuleDataType {
        return new TAppHomePageModuleDataType({ customData });
    }
    public static fromIsThisYouData(isThisYouData: TAppIsThisYouData): TAppHomePageModuleDataType {
        return new TAppHomePageModuleDataType({ isThisYouData });
    }
    public static fromAdditionalSelfContactData(additionalSelfContactData: TAppAdditionalSelfContactData): TAppHomePageModuleDataType {
        return new TAppHomePageModuleDataType({ additionalSelfContactData });
    }
    public static fromStatsData(statsData: TAppStatsData): TAppHomePageModuleDataType {
        return new TAppHomePageModuleDataType({ statsData });
    }
    public static fromWebAuthData(webAuthData: TAppWebAuthData): TAppHomePageModuleDataType {
        return new TAppHomePageModuleDataType({ webAuthData });
    }
    public static fromReverseIndexSuggestedShareData(reverseIndexSuggestedShareData: TAppReverseIndexSuggestedShareData): TAppHomePageModuleDataType {
        return new TAppHomePageModuleDataType({ reverseIndexSuggestedShareData });
    }
    public static fromAddNearbyShareRequestData(addNearbyShareRequestData: TAppAddNearbyShareRequestData): TAppHomePageModuleDataType {
        return new TAppHomePageModuleDataType({ addNearbyShareRequestData });
    }
    public static fromFetchHomepageDataRequest(fetchHomepageDataRequest: TFetchHomepageDataRequest): TAppHomePageModuleDataType {
        return new TAppHomePageModuleDataType({ fetchHomepageDataRequest });
    }
    public static fromGenericNotification(genericNotification: TAppGenericNotification): TAppHomePageModuleDataType {
        return new TAppHomePageModuleDataType({ genericNotification });
    }
    public static fromGenericNotificationData(genericNotificationData: TAppGenericNotificationData): TAppHomePageModuleDataType {
        return new TAppHomePageModuleDataType({ genericNotificationData });
    }
    public static fromNameSuggestionData(nameSuggestionData: TAppNameSuggestionData): TAppHomePageModuleDataType {
        return new TAppHomePageModuleDataType({ nameSuggestionData });
    }
    public static fromUnarchiveSuggestionData(unarchiveSuggestionData: TAppUnarchiveSuggestionData): TAppHomePageModuleDataType {
        return new TAppHomePageModuleDataType({ unarchiveSuggestionData });
    }
    public static fromShareSuggestionData(shareSuggestionData: TAppShareSuggestionData): TAppHomePageModuleDataType {
        return new TAppHomePageModuleDataType({ shareSuggestionData });
    }
    public static fromShareSelfData(shareSelfData: TAppShareSelfData): TAppHomePageModuleDataType {
        return new TAppHomePageModuleDataType({ shareSelfData });
    }
    public static fromShareOtherData(shareOtherData: TAppShareOtherData): TAppHomePageModuleDataType {
        return new TAppHomePageModuleDataType({ shareOtherData });
    }
    public static fromSingleIntroDuctionData(singleIntroDuctionData: TAppSingleIntroductionData): TAppHomePageModuleDataType {
        return new TAppHomePageModuleDataType({ singleIntroDuctionData });
    }
    public static fromGmailProcessingStatusData(gmailProcessingStatusData: TAppGmailProcessingStatusData): TAppHomePageModuleDataType {
        return new TAppHomePageModuleDataType({ gmailProcessingStatusData });
    }
    public static fromNameCompletionData(nameCompletionData: TAppNameCompletionData): TAppHomePageModuleDataType {
        return new TAppHomePageModuleDataType({ nameCompletionData });
    }
    public static fromSyncUserStatusData(syncUserStatusData: TAppExportSyncUserStatusData): TAppHomePageModuleDataType {
        return new TAppHomePageModuleDataType({ syncUserStatusData });
    }
    public static fromSyncAccountStatusData(syncAccountStatusData: TAppExportSyncAccountStatusData): TAppHomePageModuleDataType {
        return new TAppHomePageModuleDataType({ syncAccountStatusData });
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppHomePageModuleDataType");
        if (this.enhancementMetricsData != null) {
            output.writeFieldBegin("enhancementMetricsData", thrift.Thrift.Type.STRUCT, 1);
            this.enhancementMetricsData.write(output);
            output.writeFieldEnd();
        }
        if (this.welcomeData != null) {
            output.writeFieldBegin("welcomeData", thrift.Thrift.Type.STRUCT, 2);
            this.welcomeData.write(output);
            output.writeFieldEnd();
        }
        if (this.dashboardData != null) {
            output.writeFieldBegin("dashboardData", thrift.Thrift.Type.STRUCT, 3);
            this.dashboardData.write(output);
            output.writeFieldEnd();
        }
        if (this.topContactData != null) {
            output.writeFieldBegin("topContactData", thrift.Thrift.Type.STRUCT, 4);
            this.topContactData.write(output);
            output.writeFieldEnd();
        }
        if (this.topContactsData != null) {
            output.writeFieldBegin("topContactsData", thrift.Thrift.Type.STRUCT, 5);
            this.topContactsData.write(output);
            output.writeFieldEnd();
        }
        if (this.nearbyData != null) {
            output.writeFieldBegin("nearbyData", thrift.Thrift.Type.STRUCT, 6);
            this.nearbyData.write(output);
            output.writeFieldEnd();
        }
        if (this.birthdayContactData != null) {
            output.writeFieldBegin("birthdayContactData", thrift.Thrift.Type.STRUCT, 7);
            this.birthdayContactData.write(output);
            output.writeFieldEnd();
        }
        if (this.birthdayData != null) {
            output.writeFieldBegin("birthdayData", thrift.Thrift.Type.STRUCT, 8);
            this.birthdayData.write(output);
            output.writeFieldEnd();
        }
        if (this.mergeSuggestion != null) {
            output.writeFieldBegin("mergeSuggestion", thrift.Thrift.Type.STRUCT, 9);
            this.mergeSuggestion.write(output);
            output.writeFieldEnd();
        }
        if (this.mergeConfirmationData != null) {
            output.writeFieldBegin("mergeConfirmationData", thrift.Thrift.Type.STRUCT, 10);
            this.mergeConfirmationData.write(output);
            output.writeFieldEnd();
        }
        if (this.mergeSuggestionData != null) {
            output.writeFieldBegin("mergeSuggestionData", thrift.Thrift.Type.STRUCT, 35);
            this.mergeSuggestionData.write(output);
            output.writeFieldEnd();
        }
        if (this.shareRequestContactData != null) {
            output.writeFieldBegin("shareRequestContactData", thrift.Thrift.Type.STRUCT, 11);
            this.shareRequestContactData.write(output);
            output.writeFieldEnd();
        }
        if (this.shareRequestData != null) {
            output.writeFieldBegin("shareRequestData", thrift.Thrift.Type.STRUCT, 12);
            this.shareRequestData.write(output);
            output.writeFieldEnd();
        }
        if (this.introductionContact != null) {
            output.writeFieldBegin("introductionContact", thrift.Thrift.Type.STRUCT, 13);
            this.introductionContact.write(output);
            output.writeFieldEnd();
        }
        if (this.introductionData != null) {
            output.writeFieldBegin("introductionData", thrift.Thrift.Type.STRUCT, 14);
            this.introductionData.write(output);
            output.writeFieldEnd();
        }
        if (this.engagementData != null) {
            output.writeFieldBegin("engagementData", thrift.Thrift.Type.STRUCT, 15);
            this.engagementData.write(output);
            output.writeFieldEnd();
        }
        if (this.lumiAssistantData != null) {
            output.writeFieldBegin("lumiAssistantData", thrift.Thrift.Type.STRUCT, 16);
            this.lumiAssistantData.write(output);
            output.writeFieldEnd();
        }
        if (this.customData != null) {
            output.writeFieldBegin("customData", thrift.Thrift.Type.STRUCT, 17);
            this.customData.write(output);
            output.writeFieldEnd();
        }
        if (this.isThisYouData != null) {
            output.writeFieldBegin("isThisYouData", thrift.Thrift.Type.STRUCT, 34);
            this.isThisYouData.write(output);
            output.writeFieldEnd();
        }
        if (this.additionalSelfContactData != null) {
            output.writeFieldBegin("additionalSelfContactData", thrift.Thrift.Type.STRUCT, 18);
            this.additionalSelfContactData.write(output);
            output.writeFieldEnd();
        }
        if (this.statsData != null) {
            output.writeFieldBegin("statsData", thrift.Thrift.Type.STRUCT, 19);
            this.statsData.write(output);
            output.writeFieldEnd();
        }
        if (this.webAuthData != null) {
            output.writeFieldBegin("webAuthData", thrift.Thrift.Type.STRUCT, 20);
            this.webAuthData.write(output);
            output.writeFieldEnd();
        }
        if (this.reverseIndexSuggestedShareData != null) {
            output.writeFieldBegin("reverseIndexSuggestedShareData", thrift.Thrift.Type.STRUCT, 21);
            this.reverseIndexSuggestedShareData.write(output);
            output.writeFieldEnd();
        }
        if (this.addNearbyShareRequestData != null) {
            output.writeFieldBegin("addNearbyShareRequestData", thrift.Thrift.Type.STRUCT, 22);
            this.addNearbyShareRequestData.write(output);
            output.writeFieldEnd();
        }
        if (this.fetchHomepageDataRequest != null) {
            output.writeFieldBegin("fetchHomepageDataRequest", thrift.Thrift.Type.STRUCT, 23);
            this.fetchHomepageDataRequest.write(output);
            output.writeFieldEnd();
        }
        if (this.genericNotification != null) {
            output.writeFieldBegin("genericNotification", thrift.Thrift.Type.STRUCT, 33);
            this.genericNotification.write(output);
            output.writeFieldEnd();
        }
        if (this.genericNotificationData != null) {
            output.writeFieldBegin("genericNotificationData", thrift.Thrift.Type.STRUCT, 24);
            this.genericNotificationData.write(output);
            output.writeFieldEnd();
        }
        if (this.nameSuggestionData != null) {
            output.writeFieldBegin("nameSuggestionData", thrift.Thrift.Type.STRUCT, 25);
            this.nameSuggestionData.write(output);
            output.writeFieldEnd();
        }
        if (this.unarchiveSuggestionData != null) {
            output.writeFieldBegin("unarchiveSuggestionData", thrift.Thrift.Type.STRUCT, 26);
            this.unarchiveSuggestionData.write(output);
            output.writeFieldEnd();
        }
        if (this.shareSuggestionData != null) {
            output.writeFieldBegin("shareSuggestionData", thrift.Thrift.Type.STRUCT, 29);
            this.shareSuggestionData.write(output);
            output.writeFieldEnd();
        }
        if (this.shareSelfData != null) {
            output.writeFieldBegin("shareSelfData", thrift.Thrift.Type.STRUCT, 30);
            this.shareSelfData.write(output);
            output.writeFieldEnd();
        }
        if (this.shareOtherData != null) {
            output.writeFieldBegin("shareOtherData", thrift.Thrift.Type.STRUCT, 31);
            this.shareOtherData.write(output);
            output.writeFieldEnd();
        }
        if (this.singleIntroDuctionData != null) {
            output.writeFieldBegin("singleIntroDuctionData", thrift.Thrift.Type.STRUCT, 32);
            this.singleIntroDuctionData.write(output);
            output.writeFieldEnd();
        }
        if (this.gmailProcessingStatusData != null) {
            output.writeFieldBegin("gmailProcessingStatusData", thrift.Thrift.Type.STRUCT, 36);
            this.gmailProcessingStatusData.write(output);
            output.writeFieldEnd();
        }
        if (this.nameCompletionData != null) {
            output.writeFieldBegin("nameCompletionData", thrift.Thrift.Type.STRUCT, 37);
            this.nameCompletionData.write(output);
            output.writeFieldEnd();
        }
        if (this.syncUserStatusData != null) {
            output.writeFieldBegin("syncUserStatusData", thrift.Thrift.Type.STRUCT, 38);
            this.syncUserStatusData.write(output);
            output.writeFieldEnd();
        }
        if (this.syncAccountStatusData != null) {
            output.writeFieldBegin("syncAccountStatusData", thrift.Thrift.Type.STRUCT, 39);
            this.syncAccountStatusData.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppHomePageModuleDataType {
        let _fieldsSet: number = 0;
        let _returnValue: TAppHomePageModuleDataType | null = null;
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_198: TAppEnhancementMetrics = TAppEnhancementMetrics.read(input);
                        _returnValue = TAppHomePageModuleDataType.fromEnhancementMetricsData(value_198);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_199: TAppWelcomeData = TAppWelcomeData.read(input);
                        _returnValue = TAppHomePageModuleDataType.fromWelcomeData(value_199);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_200: TAppDashboardData = TAppDashboardData.read(input);
                        _returnValue = TAppHomePageModuleDataType.fromDashboardData(value_200);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_201: TAppTopContact = TAppTopContact.read(input);
                        _returnValue = TAppHomePageModuleDataType.fromTopContactData(value_201);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_202: TAppTopContactsData = TAppTopContactsData.read(input);
                        _returnValue = TAppHomePageModuleDataType.fromTopContactsData(value_202);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 6:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_203: TAppNearbyData = TAppNearbyData.read(input);
                        _returnValue = TAppHomePageModuleDataType.fromNearbyData(value_203);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 7:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_204: TAppBirthdayContact = TAppBirthdayContact.read(input);
                        _returnValue = TAppHomePageModuleDataType.fromBirthdayContactData(value_204);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 8:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_205: TAppBirthdayData = TAppBirthdayData.read(input);
                        _returnValue = TAppHomePageModuleDataType.fromBirthdayData(value_205);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 9:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_206: TAppMergeSuggestion = TAppMergeSuggestion.read(input);
                        _returnValue = TAppHomePageModuleDataType.fromMergeSuggestion(value_206);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 10:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_207: TAppMergeConfirmationData = TAppMergeConfirmationData.read(input);
                        _returnValue = TAppHomePageModuleDataType.fromMergeConfirmationData(value_207);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 35:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_208: TAppMergeSuggestionData = TAppMergeSuggestionData.read(input);
                        _returnValue = TAppHomePageModuleDataType.fromMergeSuggestionData(value_208);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 11:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_209: TAppShareRequestContact = TAppShareRequestContact.read(input);
                        _returnValue = TAppHomePageModuleDataType.fromShareRequestContactData(value_209);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 12:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_210: TAppShareRequestData = TAppShareRequestData.read(input);
                        _returnValue = TAppHomePageModuleDataType.fromShareRequestData(value_210);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 13:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_211: TAppIntroductionContact = TAppIntroductionContact.read(input);
                        _returnValue = TAppHomePageModuleDataType.fromIntroductionContact(value_211);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 14:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_212: TAppIntroductionData = TAppIntroductionData.read(input);
                        _returnValue = TAppHomePageModuleDataType.fromIntroductionData(value_212);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 15:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_213: TAppEngagementData = TAppEngagementData.read(input);
                        _returnValue = TAppHomePageModuleDataType.fromEngagementData(value_213);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 16:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_214: TAppLumiAssistantData = TAppLumiAssistantData.read(input);
                        _returnValue = TAppHomePageModuleDataType.fromLumiAssistantData(value_214);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 17:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_215: TAppCustomData = TAppCustomData.read(input);
                        _returnValue = TAppHomePageModuleDataType.fromCustomData(value_215);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 34:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_216: TAppIsThisYouData = TAppIsThisYouData.read(input);
                        _returnValue = TAppHomePageModuleDataType.fromIsThisYouData(value_216);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 18:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_217: TAppAdditionalSelfContactData = TAppAdditionalSelfContactData.read(input);
                        _returnValue = TAppHomePageModuleDataType.fromAdditionalSelfContactData(value_217);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 19:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_218: TAppStatsData = TAppStatsData.read(input);
                        _returnValue = TAppHomePageModuleDataType.fromStatsData(value_218);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 20:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_219: TAppWebAuthData = TAppWebAuthData.read(input);
                        _returnValue = TAppHomePageModuleDataType.fromWebAuthData(value_219);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 21:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_220: TAppReverseIndexSuggestedShareData = TAppReverseIndexSuggestedShareData.read(input);
                        _returnValue = TAppHomePageModuleDataType.fromReverseIndexSuggestedShareData(value_220);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 22:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_221: TAppAddNearbyShareRequestData = TAppAddNearbyShareRequestData.read(input);
                        _returnValue = TAppHomePageModuleDataType.fromAddNearbyShareRequestData(value_221);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 23:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_222: TFetchHomepageDataRequest = TFetchHomepageDataRequest.read(input);
                        _returnValue = TAppHomePageModuleDataType.fromFetchHomepageDataRequest(value_222);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 33:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_223: TAppGenericNotification = TAppGenericNotification.read(input);
                        _returnValue = TAppHomePageModuleDataType.fromGenericNotification(value_223);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 24:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_224: TAppGenericNotificationData = TAppGenericNotificationData.read(input);
                        _returnValue = TAppHomePageModuleDataType.fromGenericNotificationData(value_224);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 25:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_225: TAppNameSuggestionData = TAppNameSuggestionData.read(input);
                        _returnValue = TAppHomePageModuleDataType.fromNameSuggestionData(value_225);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 26:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_226: TAppUnarchiveSuggestionData = TAppUnarchiveSuggestionData.read(input);
                        _returnValue = TAppHomePageModuleDataType.fromUnarchiveSuggestionData(value_226);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 29:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_227: TAppShareSuggestionData = TAppShareSuggestionData.read(input);
                        _returnValue = TAppHomePageModuleDataType.fromShareSuggestionData(value_227);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 30:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_228: TAppShareSelfData = TAppShareSelfData.read(input);
                        _returnValue = TAppHomePageModuleDataType.fromShareSelfData(value_228);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 31:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_229: TAppShareOtherData = TAppShareOtherData.read(input);
                        _returnValue = TAppHomePageModuleDataType.fromShareOtherData(value_229);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 32:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_230: TAppSingleIntroductionData = TAppSingleIntroductionData.read(input);
                        _returnValue = TAppHomePageModuleDataType.fromSingleIntroDuctionData(value_230);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 36:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_231: TAppGmailProcessingStatusData = TAppGmailProcessingStatusData.read(input);
                        _returnValue = TAppHomePageModuleDataType.fromGmailProcessingStatusData(value_231);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 37:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_232: TAppNameCompletionData = TAppNameCompletionData.read(input);
                        _returnValue = TAppHomePageModuleDataType.fromNameCompletionData(value_232);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 38:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_233: TAppExportSyncUserStatusData = TAppExportSyncUserStatusData.read(input);
                        _returnValue = TAppHomePageModuleDataType.fromSyncUserStatusData(value_233);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 39:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_234: TAppExportSyncAccountStatusData = TAppExportSyncAccountStatusData.read(input);
                        _returnValue = TAppHomePageModuleDataType.fromSyncAccountStatusData(value_234);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_fieldsSet > 1) {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.INVALID_DATA, "Cannot read a TUnion with more than one set value!");
        }
        else if (_fieldsSet < 1) {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.INVALID_DATA, "Cannot read a TUnion with no set value!");
        }
        if (_returnValue !== null) {
            return _returnValue;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read data for TUnion");
        }
    }
}
export interface ITAppNameSuggestionArgs {
    contactId?: string;
    originalContactIds?: Array<string>;
    alternateNames?: Array<PContact.TAppName>;
    selectedName?: PContact.TAppName;
    appContact?: PContact.TAppContact;
}
export class TAppNameSuggestion {
    public contactId?: string;
    public originalContactIds?: Array<string>;
    public alternateNames?: Array<PContact.TAppName>;
    public selectedName?: PContact.TAppName;
    public appContact?: PContact.TAppContact;
    constructor(args?: ITAppNameSuggestionArgs) {
        if (args != null && args.contactId != null) {
            this.contactId = args.contactId;
        }
        if (args != null && args.originalContactIds != null) {
            this.originalContactIds = args.originalContactIds;
        }
        if (args != null && args.alternateNames != null) {
            this.alternateNames = args.alternateNames;
        }
        if (args != null && args.selectedName != null) {
            this.selectedName = args.selectedName;
        }
        if (args != null && args.appContact != null) {
            this.appContact = args.appContact;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppNameSuggestion");
        if (this.contactId != null) {
            output.writeFieldBegin("contactId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.contactId);
            output.writeFieldEnd();
        }
        if (this.originalContactIds != null) {
            output.writeFieldBegin("originalContactIds", thrift.Thrift.Type.LIST, 2);
            output.writeListBegin(thrift.Thrift.Type.STRING, this.originalContactIds.length);
            this.originalContactIds.forEach((value_235: string): void => {
                output.writeString(value_235);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.alternateNames != null) {
            output.writeFieldBegin("alternateNames", thrift.Thrift.Type.LIST, 3);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.alternateNames.length);
            this.alternateNames.forEach((value_236: PContact.TAppName): void => {
                value_236.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.selectedName != null) {
            output.writeFieldBegin("selectedName", thrift.Thrift.Type.STRUCT, 4);
            this.selectedName.write(output);
            output.writeFieldEnd();
        }
        if (this.appContact != null) {
            output.writeFieldBegin("appContact", thrift.Thrift.Type.STRUCT, 5);
            this.appContact.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppNameSuggestion {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_237: string = input.readString();
                        _args.contactId = value_237;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_238: Array<string> = new Array<string>();
                        const metadata_25: thrift.TList = input.readListBegin();
                        const size_25: number = metadata_25.size;
                        for (let i_25: number = 0; i_25 < size_25; i_25++) {
                            const value_239: string = input.readString();
                            value_238.push(value_239);
                        }
                        input.readListEnd();
                        _args.originalContactIds = value_238;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_240: Array<PContact.TAppName> = new Array<PContact.TAppName>();
                        const metadata_26: thrift.TList = input.readListBegin();
                        const size_26: number = metadata_26.size;
                        for (let i_26: number = 0; i_26 < size_26; i_26++) {
                            const value_241: PContact.TAppName = PContact.TAppName.read(input);
                            value_240.push(value_241);
                        }
                        input.readListEnd();
                        _args.alternateNames = value_240;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_242: PContact.TAppName = PContact.TAppName.read(input);
                        _args.selectedName = value_242;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_243: PContact.TAppContact = PContact.TAppContact.read(input);
                        _args.appContact = value_243;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppNameSuggestion(_args);
    }
}
export interface ITNameSuggestionFetchRequestArgs {
}
export class TNameSuggestionFetchRequest {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TNameSuggestionFetchRequest");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TNameSuggestionFetchRequest {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TNameSuggestionFetchRequest();
    }
}
export interface ITNameSuggestionFetchResponseArgs {
    nameSuggestions?: Array<TAppNameSuggestion>;
}
export class TNameSuggestionFetchResponse {
    public nameSuggestions?: Array<TAppNameSuggestion>;
    constructor(args?: ITNameSuggestionFetchResponseArgs) {
        if (args != null && args.nameSuggestions != null) {
            this.nameSuggestions = args.nameSuggestions;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TNameSuggestionFetchResponse");
        if (this.nameSuggestions != null) {
            output.writeFieldBegin("nameSuggestions", thrift.Thrift.Type.LIST, 1);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.nameSuggestions.length);
            this.nameSuggestions.forEach((value_244: TAppNameSuggestion): void => {
                value_244.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TNameSuggestionFetchResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_245: Array<TAppNameSuggestion> = new Array<TAppNameSuggestion>();
                        const metadata_27: thrift.TList = input.readListBegin();
                        const size_27: number = metadata_27.size;
                        for (let i_27: number = 0; i_27 < size_27; i_27++) {
                            const value_246: TAppNameSuggestion = TAppNameSuggestion.read(input);
                            value_245.push(value_246);
                        }
                        input.readListEnd();
                        _args.nameSuggestions = value_245;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TNameSuggestionFetchResponse(_args);
    }
}
export interface ITNameSuggestionUpdateRequestArgs {
    userResponse?: Array<TAppNameSuggestion>;
}
export class TNameSuggestionUpdateRequest {
    public userResponse?: Array<TAppNameSuggestion>;
    constructor(args?: ITNameSuggestionUpdateRequestArgs) {
        if (args != null && args.userResponse != null) {
            this.userResponse = args.userResponse;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TNameSuggestionUpdateRequest");
        if (this.userResponse != null) {
            output.writeFieldBegin("userResponse", thrift.Thrift.Type.LIST, 1);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.userResponse.length);
            this.userResponse.forEach((value_247: TAppNameSuggestion): void => {
                value_247.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TNameSuggestionUpdateRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_248: Array<TAppNameSuggestion> = new Array<TAppNameSuggestion>();
                        const metadata_28: thrift.TList = input.readListBegin();
                        const size_28: number = metadata_28.size;
                        for (let i_28: number = 0; i_28 < size_28; i_28++) {
                            const value_249: TAppNameSuggestion = TAppNameSuggestion.read(input);
                            value_248.push(value_249);
                        }
                        input.readListEnd();
                        _args.userResponse = value_248;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TNameSuggestionUpdateRequest(_args);
    }
}
export interface ITNameSuggestionUpdateResponseArgs {
}
export class TNameSuggestionUpdateResponse {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TNameSuggestionUpdateResponse");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TNameSuggestionUpdateResponse {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TNameSuggestionUpdateResponse();
    }
}
export enum TUnarchiveStatus {
    PENDING = 0,
    ACCEPTED = 1,
    REJECTED = 2
}
export interface ITAppUnarchiveSuggestionArgs {
    appContact: PContact.TAppContact;
    unarchiveStatus: TUnarchiveStatus;
}
export class TAppUnarchiveSuggestion {
    public appContact: PContact.TAppContact;
    public unarchiveStatus: TUnarchiveStatus;
    constructor(args: ITAppUnarchiveSuggestionArgs) {
        if (args != null && args.appContact != null) {
            this.appContact = args.appContact;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[appContact] is unset!");
        }
        if (args != null && args.unarchiveStatus != null) {
            this.unarchiveStatus = args.unarchiveStatus;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[unarchiveStatus] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppUnarchiveSuggestion");
        if (this.appContact != null) {
            output.writeFieldBegin("appContact", thrift.Thrift.Type.STRUCT, 1);
            this.appContact.write(output);
            output.writeFieldEnd();
        }
        if (this.unarchiveStatus != null) {
            output.writeFieldBegin("unarchiveStatus", thrift.Thrift.Type.I32, 2);
            output.writeI32(this.unarchiveStatus);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppUnarchiveSuggestion {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_250: PContact.TAppContact = PContact.TAppContact.read(input);
                        _args.appContact = value_250;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_251: TUnarchiveStatus = input.readI32();
                        _args.unarchiveStatus = value_251;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.appContact !== undefined && _args.unarchiveStatus !== undefined) {
            return new TAppUnarchiveSuggestion(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppUnarchiveSuggestion from input");
        }
    }
}
export interface ITUnarchiveSuggestionFetchRequestArgs {
    maxPageSize?: number;
}
export class TUnarchiveSuggestionFetchRequest {
    public maxPageSize?: number;
    constructor(args?: ITUnarchiveSuggestionFetchRequestArgs) {
        if (args != null && args.maxPageSize != null) {
            this.maxPageSize = args.maxPageSize;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TUnarchiveSuggestionFetchRequest");
        if (this.maxPageSize != null) {
            output.writeFieldBegin("maxPageSize", thrift.Thrift.Type.I16, 1);
            output.writeI16(this.maxPageSize);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TUnarchiveSuggestionFetchRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.I16) {
                        const value_252: number = input.readI16();
                        _args.maxPageSize = value_252;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TUnarchiveSuggestionFetchRequest(_args);
    }
}
export interface ITUnarchiveSuggestionFetchResponseArgs {
    unarchiveSuggestions?: Array<TAppUnarchiveSuggestion>;
}
export class TUnarchiveSuggestionFetchResponse {
    public unarchiveSuggestions?: Array<TAppUnarchiveSuggestion>;
    constructor(args?: ITUnarchiveSuggestionFetchResponseArgs) {
        if (args != null && args.unarchiveSuggestions != null) {
            this.unarchiveSuggestions = args.unarchiveSuggestions;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TUnarchiveSuggestionFetchResponse");
        if (this.unarchiveSuggestions != null) {
            output.writeFieldBegin("unarchiveSuggestions", thrift.Thrift.Type.LIST, 1);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.unarchiveSuggestions.length);
            this.unarchiveSuggestions.forEach((value_253: TAppUnarchiveSuggestion): void => {
                value_253.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TUnarchiveSuggestionFetchResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_254: Array<TAppUnarchiveSuggestion> = new Array<TAppUnarchiveSuggestion>();
                        const metadata_29: thrift.TList = input.readListBegin();
                        const size_29: number = metadata_29.size;
                        for (let i_29: number = 0; i_29 < size_29; i_29++) {
                            const value_255: TAppUnarchiveSuggestion = TAppUnarchiveSuggestion.read(input);
                            value_254.push(value_255);
                        }
                        input.readListEnd();
                        _args.unarchiveSuggestions = value_254;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TUnarchiveSuggestionFetchResponse(_args);
    }
}
export interface ITUnarchiveSuggestionUpdateRequestArgs {
    userResponses?: Array<TAppUnarchiveSuggestion>;
}
export class TUnarchiveSuggestionUpdateRequest {
    public userResponses?: Array<TAppUnarchiveSuggestion>;
    constructor(args?: ITUnarchiveSuggestionUpdateRequestArgs) {
        if (args != null && args.userResponses != null) {
            this.userResponses = args.userResponses;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TUnarchiveSuggestionUpdateRequest");
        if (this.userResponses != null) {
            output.writeFieldBegin("userResponses", thrift.Thrift.Type.LIST, 1);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.userResponses.length);
            this.userResponses.forEach((value_256: TAppUnarchiveSuggestion): void => {
                value_256.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TUnarchiveSuggestionUpdateRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_257: Array<TAppUnarchiveSuggestion> = new Array<TAppUnarchiveSuggestion>();
                        const metadata_30: thrift.TList = input.readListBegin();
                        const size_30: number = metadata_30.size;
                        for (let i_30: number = 0; i_30 < size_30; i_30++) {
                            const value_258: TAppUnarchiveSuggestion = TAppUnarchiveSuggestion.read(input);
                            value_257.push(value_258);
                        }
                        input.readListEnd();
                        _args.userResponses = value_257;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TUnarchiveSuggestionUpdateRequest(_args);
    }
}
export interface ITUnarchiveSuggestionUpdateResponseArgs {
}
export class TUnarchiveSuggestionUpdateResponse {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TUnarchiveSuggestionUpdateResponse");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TUnarchiveSuggestionUpdateResponse {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TUnarchiveSuggestionUpdateResponse();
    }
}
export enum Suspicious {
    UNDEFINED = 0,
    YES = 1,
    NO = 2,
    DONT_KNOW = 3,
    SHARED = 4
}
export interface ITAppSuspiciousContactArgs {
    contactId: string;
    contact?: PContact.TAppContact;
    suspicious?: Suspicious;
    notes?: string;
    suspiciousReason?: string;
    piiResponseMap?: Map<string, Suspicious>;
}
export class TAppSuspiciousContact {
    public contactId: string;
    public contact?: PContact.TAppContact;
    public suspicious?: Suspicious;
    public notes?: string;
    public suspiciousReason?: string;
    public piiResponseMap?: Map<string, Suspicious>;
    constructor(args: ITAppSuspiciousContactArgs) {
        if (args != null && args.contactId != null) {
            this.contactId = args.contactId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[contactId] is unset!");
        }
        if (args != null && args.contact != null) {
            this.contact = args.contact;
        }
        if (args != null && args.suspicious != null) {
            this.suspicious = args.suspicious;
        }
        if (args != null && args.notes != null) {
            this.notes = args.notes;
        }
        if (args != null && args.suspiciousReason != null) {
            this.suspiciousReason = args.suspiciousReason;
        }
        if (args != null && args.piiResponseMap != null) {
            this.piiResponseMap = args.piiResponseMap;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppSuspiciousContact");
        if (this.contactId != null) {
            output.writeFieldBegin("contactId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.contactId);
            output.writeFieldEnd();
        }
        if (this.contact != null) {
            output.writeFieldBegin("contact", thrift.Thrift.Type.STRUCT, 2);
            this.contact.write(output);
            output.writeFieldEnd();
        }
        if (this.suspicious != null) {
            output.writeFieldBegin("suspicious", thrift.Thrift.Type.I32, 3);
            output.writeI32(this.suspicious);
            output.writeFieldEnd();
        }
        if (this.notes != null) {
            output.writeFieldBegin("notes", thrift.Thrift.Type.STRING, 4);
            output.writeString(this.notes);
            output.writeFieldEnd();
        }
        if (this.suspiciousReason != null) {
            output.writeFieldBegin("suspiciousReason", thrift.Thrift.Type.STRING, 5);
            output.writeString(this.suspiciousReason);
            output.writeFieldEnd();
        }
        if (this.piiResponseMap != null) {
            output.writeFieldBegin("piiResponseMap", thrift.Thrift.Type.MAP, 6);
            output.writeMapBegin(thrift.Thrift.Type.STRING, thrift.Thrift.Type.I32, this.piiResponseMap.size);
            this.piiResponseMap.forEach((value_259: Suspicious, key_5: string): void => {
                output.writeString(key_5);
                output.writeI32(value_259);
            });
            output.writeMapEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppSuspiciousContact {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_260: string = input.readString();
                        _args.contactId = value_260;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_261: PContact.TAppContact = PContact.TAppContact.read(input);
                        _args.contact = value_261;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_262: Suspicious = input.readI32();
                        _args.suspicious = value_262;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_263: string = input.readString();
                        _args.notes = value_263;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_264: string = input.readString();
                        _args.suspiciousReason = value_264;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 6:
                    if (fieldType === thrift.Thrift.Type.MAP) {
                        const value_265: Map<string, Suspicious> = new Map<string, Suspicious>();
                        const metadata_31: thrift.TMap = input.readMapBegin();
                        const size_31: number = metadata_31.size;
                        for (let i_31: number = 0; i_31 < size_31; i_31++) {
                            const key_6: string = input.readString();
                            const value_266: Suspicious = input.readI32();
                            value_265.set(key_6, value_266);
                        }
                        input.readMapEnd();
                        _args.piiResponseMap = value_265;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.contactId !== undefined) {
            return new TAppSuspiciousContact(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppSuspiciousContact from input");
        }
    }
}
export interface ITSuspiciousContactsFetchRequestArgs {
    maxPageSize: number;
}
export class TSuspiciousContactsFetchRequest {
    public maxPageSize: number;
    constructor(args: ITSuspiciousContactsFetchRequestArgs) {
        if (args != null && args.maxPageSize != null) {
            this.maxPageSize = args.maxPageSize;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[maxPageSize] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TSuspiciousContactsFetchRequest");
        if (this.maxPageSize != null) {
            output.writeFieldBegin("maxPageSize", thrift.Thrift.Type.I32, 1);
            output.writeI32(this.maxPageSize);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TSuspiciousContactsFetchRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_267: number = input.readI32();
                        _args.maxPageSize = value_267;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.maxPageSize !== undefined) {
            return new TSuspiciousContactsFetchRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TSuspiciousContactsFetchRequest from input");
        }
    }
}
export interface ITSuspiciousContactsFetchResponseArgs {
    susContacts: Array<TAppSuspiciousContact>;
}
export class TSuspiciousContactsFetchResponse {
    public susContacts: Array<TAppSuspiciousContact>;
    constructor(args: ITSuspiciousContactsFetchResponseArgs) {
        if (args != null && args.susContacts != null) {
            this.susContacts = args.susContacts;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[susContacts] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TSuspiciousContactsFetchResponse");
        if (this.susContacts != null) {
            output.writeFieldBegin("susContacts", thrift.Thrift.Type.LIST, 1);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.susContacts.length);
            this.susContacts.forEach((value_268: TAppSuspiciousContact): void => {
                value_268.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TSuspiciousContactsFetchResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_269: Array<TAppSuspiciousContact> = new Array<TAppSuspiciousContact>();
                        const metadata_32: thrift.TList = input.readListBegin();
                        const size_32: number = metadata_32.size;
                        for (let i_32: number = 0; i_32 < size_32; i_32++) {
                            const value_270: TAppSuspiciousContact = TAppSuspiciousContact.read(input);
                            value_269.push(value_270);
                        }
                        input.readListEnd();
                        _args.susContacts = value_269;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.susContacts !== undefined) {
            return new TSuspiciousContactsFetchResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TSuspiciousContactsFetchResponse from input");
        }
    }
}
export interface ITSuspiciousContactsUpdateRequestArgs {
    susContact: TAppSuspiciousContact;
}
export class TSuspiciousContactsUpdateRequest {
    public susContact: TAppSuspiciousContact;
    constructor(args: ITSuspiciousContactsUpdateRequestArgs) {
        if (args != null && args.susContact != null) {
            this.susContact = args.susContact;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[susContact] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TSuspiciousContactsUpdateRequest");
        if (this.susContact != null) {
            output.writeFieldBegin("susContact", thrift.Thrift.Type.STRUCT, 1);
            this.susContact.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TSuspiciousContactsUpdateRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_271: TAppSuspiciousContact = TAppSuspiciousContact.read(input);
                        _args.susContact = value_271;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.susContact !== undefined) {
            return new TSuspiciousContactsUpdateRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TSuspiciousContactsUpdateRequest from input");
        }
    }
}
export interface ITSuspiciousContactsUpdateResponseArgs {
}
export class TSuspiciousContactsUpdateResponse {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TSuspiciousContactsUpdateResponse");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TSuspiciousContactsUpdateResponse {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TSuspiciousContactsUpdateResponse();
    }
}
